/* ==========================================================================
   Stickidy Customizer — kişiselleştirilebilir cihaz kaplaması editörü
   Bağımsız (vanilla JS), bağımlılık yok. Tema: Area (Shopify).
   ========================================================================== */
(function () {
  'use strict';
  if (window.StickidyCustomizer) return;

  var MM_PER_INCH = 25.4;
  var DISPLAY_MAX = 2048;       // ekranda çizilen kopyanın uzun kenarı (px)
  var PRINT_MAX_PIXELS = 22e6;  // baskı dosyası üst sınırı (px) — dpi otomatik düşer
  var MAX_UPLOAD_BYTES = 19 * 1024 * 1024; // Shopify line-item dosya limiti 20 MB (dosya başına)
  var MAX_TOTAL_BYTES = 19.5 * 1024 * 1024; // tek istekte tüm dosyalar
  var MAX_FILE_BYTES = 40 * 1024 * 1024;    // kaynak fotoğraf üst sınırı
  var SOURCE_MAX_LONG = 6000;               // kaynak görsel uzun kenar üst sınırı (px) — bellek koruması
  var UPLOAD_TIMEOUT = 180000;              // ms

  /* ---------------------------------------------------------------------
     Cihaz ölçüleri (mm): [genişlik, yükseklik, köşe yarıçapı, kamera tipi]
     Anahtar = varyant model adı (küçük harf). Bulunamazsa kategori
     varsayılanı kullanılır. Tema editöründeki "Model mockup" blokları bu
     değerleri ezebilir.
     ------------------------------------------------------------------- */
  var CATEGORY_DEFAULTS = {
    artframe: [500, 700, 0, 'frame'],   // Art Frame: 50×70 cm baskı alanı; çerçeve drawFrame ile
    iphone:  [71.6, 147.6, 9.5, 'dual'],
    samsung: [70.6, 147.0, 8.0, 'sam-triple'],
    ipad:    [178.5, 247.6, 8.0, 'ipad'],
    macbook: [304.1, 215.0, 9.0, 'mac']
  };

  // Art Frame çerçeve geometrisi (mm): yüz genişliği 17, baskı kenarını örten pah 4, derinlik 27
  var FRAME = { face: 17, lip: 4, depth: 27 };
  var FRAME_COLORS = [
    { n: 'Doğal Ahşap', c: '#d8b98c', grain: '#c9a36f' }, { n: 'Siyah', c: '#232326', grain: '#1a1a1c' }, { n: 'Beyaz', c: '#f3f2ee', grain: '#e6e4de' },
    { n: 'Koyu Yeşil', c: '#2c4f3d', grain: '#244335' }, { n: 'Lacivert', c: '#24365c', grain: '#1d2c4d' }, { n: 'Pembe', c: '#f0a7c0', grain: '#e698b3' },
    { n: 'Açık Mavi', c: '#a9cbe3', grain: '#98bdd8' }, { n: 'Hardal Sarı', c: '#d9a62b', grain: '#c99824' }, { n: 'Bordo', c: '#8a2634', grain: '#77202c' }
  ];
  var DEVICES = {
    artframe: { '50 x 70 cm': [500, 700, 0, 'frame'] },
    iphone: {
      'iphone 17 pro max': [78.0, 163.4, 10, 'plateau'],
      'iphone 17 pro':     [71.9, 150.0, 10, 'plateau'],
      'iphone air':        [74.7, 156.2, 10, 'bar'],
      'iphone 17':         [71.5, 149.6, 10, 'dual-v'],
      'iphone 16 pro max': [77.6, 163.0, 10, 'triple'],
      'iphone 16 pro':     [71.5, 149.6, 10, 'triple'],
      'iphone 16 plus':    [77.8, 160.9, 10, 'dual-v'],
      'iphone 16':         [71.6, 147.6, 10, 'dual-v'],
      'iphone 16e':        [71.5, 146.7, 10, 'single'],
      'iphone 15 pro max': [76.7, 159.9, 10, 'triple'],
      'iphone 15 pro':     [70.6, 146.6, 10, 'triple'],
      'iphone 15 plus':    [77.8, 160.9, 10, 'dual'],
      'iphone 15':         [71.6, 147.6, 10, 'dual'],
      'iphone 14 pro max': [77.6, 160.7, 10, 'triple'],
      'iphone 14 pro':     [71.5, 147.5, 10, 'triple'],
      'iphone 14 plus':    [78.1, 160.8, 10, 'dual'],
      'iphone 14':         [71.5, 146.7, 10, 'dual'],
      'iphone 13 pro max': [78.1, 160.8, 10, 'triple'],
      'iphone 13 pro':     [71.5, 146.7, 10, 'triple'],
      'iphone 13':         [71.5, 146.7, 10, 'dual'],
      'iphone 13 mini':    [64.2, 131.5, 9,  'dual'],
      'iphone 12 pro max': [78.1, 160.8, 10, 'triple'],
      'iphone 12 pro':     [71.5, 146.7, 10, 'triple'],
      'iphone 12':         [71.5, 146.7, 10, 'dual'],
      'iphone 12 mini':    [64.2, 131.5, 9,  'dual'],
      'iphone 11':         [75.7, 150.9, 10, 'dual']
    },
    samsung: {
      'galaxy s26 ultra': [78.1, 163.4, 4, 'sam-ultra'],
      'galaxy s26':       [70.5, 146.9, 8, 'sam-triple'],
      'galaxy s25 ultra': [77.6, 162.8, 4, 'sam-ultra'],
      'galaxy s25 plus':  [75.8, 158.4, 8, 'sam-triple'],
      'galaxy s25':       [70.5, 146.9, 8, 'sam-triple'],
      'galaxy s24 ultra': [79.0, 162.3, 4, 'sam-ultra'],
      'galaxy s24 plus':  [75.9, 158.5, 8, 'sam-triple'],
      'galaxy s24':       [70.6, 147.0, 8, 'sam-triple'],
      'galaxy s24 fe':    [77.3, 162.0, 8, 'sam-triple'],
      'galaxy s23 ultra': [78.1, 163.4, 4, 'sam-ultra'],
      'galaxy s23 plus':  [76.2, 157.8, 8, 'sam-triple'],
      'galaxy s23':       [70.9, 146.3, 8, 'sam-triple'],
      'galaxy s23 fe':    [76.5, 158.0, 8, 'sam-triple'],
      'galaxy s22 ultra': [77.9, 163.3, 4, 'sam-ultra'],
      'galaxy s22 plus':  [75.8, 157.4, 8, 'sam-triple'],
      'galaxy s22':       [70.6, 146.0, 8, 'sam-triple'],
      'galaxy s21 ultra': [75.6, 165.1, 8, 'sam-ultra'],
      'galaxy s21':       [71.2, 151.7, 8, 'sam-triple'],
      'galaxy s21 fe':    [74.5, 155.7, 8, 'sam-triple'],
      'galaxy a73 5g':    [76.1, 163.7, 8, 'sam-triple'],
      'galaxy a55 5g':    [77.4, 161.1, 8, 'sam-triple'],
      'galaxy a54 5g':    [76.7, 158.2, 8, 'sam-triple'],
      'galaxy a53 5g':    [74.8, 159.6, 8, 'sam-triple'],
      'galaxy a35 5g':    [78.0, 161.7, 8, 'sam-triple'],
      'galaxy a34 5g':    [78.1, 161.3, 8, 'sam-triple'],
      'galaxy a33 5g':    [74.0, 159.7, 8, 'sam-triple'],
      'galaxy a25 5g':    [76.5, 161.0, 8, 'sam-triple'],
      'galaxy a24':       [77.6, 162.1, 8, 'sam-triple'],
      'galaxy a23':       [76.9, 165.4, 8, 'sam-triple'],
      'galaxy z fold 7':  [72.8, 158.4, 6, 'sam-triple'],
      'galaxy z flip 7':  [75.2, 85.5,  8, 'none'],
      'galaxy z fold 6':  [68.1, 153.5, 6, 'sam-triple'],
      'galaxy z flip 6':  [71.9, 85.1,  8, 'none']
    },
    ipad: {
      'ipad air 13 (m3) 2025': [214.9, 280.6, 8, 'ipad'],
      'ipad air 11 (m3) 2025': [178.5, 247.6, 8, 'ipad'],
      'ipad 11 (a16) 2025':    [179.5, 248.6, 8, 'ipad'],
      'ipad pro 13 m4 2024':   [215.5, 281.6, 8, 'ipad-pro'],
      'ipad pro 11 m4 2024':   [177.5, 249.7, 8, 'ipad-pro'],
      'ipad air 13 (m2) 2024': [214.9, 280.6, 8, 'ipad'],
      'ipad air 11 (m2) 2024': [178.5, 247.6, 8, 'ipad'],
      'ipad pro 12.9 m2 2022': [214.9, 280.6, 8, 'ipad-pro'],
      'ipad pro 11 m2 2022':   [178.5, 247.6, 8, 'ipad-pro'],
      'ipad 10.9 2022':        [179.5, 248.6, 8, 'ipad'],
      'ipad air 2020/2022':    [178.5, 247.6, 8, 'ipad'],
      'ipad pro 12.9 m1 2021': [214.9, 280.6, 8, 'ipad-pro'],
      'ipad pro 11 m1 2021':   [178.5, 247.6, 8, 'ipad-pro'],
      'ipad 10.2 2021':        [174.1, 250.6, 6, 'ipad'],
      'ipad mini 6 2021':      [134.8, 195.4, 8, 'ipad'],
      'ipad pro 12.9 2020':    [214.9, 280.6, 8, 'ipad-pro'],
      'ipad pro 11 2020':      [178.5, 247.6, 8, 'ipad-pro'],
      'ipad 10.2 2020':        [174.1, 250.6, 6, 'ipad']
    },
    macbook: {
      'macbook pro 16 m5':               [355.7, 248.1, 9, 'mac'],
      'macbook pro 14 m5':               [312.6, 221.2, 9, 'mac'],
      'macbook neo':                     [304.0, 212.0, 9, 'mac'],
      'macbook pro 16 m1 | m2 | m3 | m4':[355.7, 248.1, 9, 'mac'],
      'macbook pro 14 m1 | m2 | m3 | m4':[312.6, 221.2, 9, 'mac'],
      'macbook air 15 m4 (2025)':        [340.4, 237.6, 9, 'mac'],
      'macbook air 13 m4 (2025)':        [304.1, 215.0, 9, 'mac'],
      'macbook air 15 m2 | m3':          [340.4, 237.6, 9, 'mac'],
      'macbook air 13.6 m2 | m3':        [304.1, 215.0, 9, 'mac'],
      'macbook air 13 m1 (2020)':        [304.1, 212.4, 7, 'mac'],
      'macbook air 13 (2020)':           [304.1, 212.4, 7, 'mac'],
      'macbook pro 16 (2019)':           [357.9, 245.9, 7, 'mac'],
      'macbook pro 15 (2018 - 2019)':    [349.3, 240.7, 7, 'mac'],
      'macbook pro 13 (2018)':           [304.1, 212.4, 7, 'mac'],
      'macbook air 13 (2018)':           [304.1, 212.4, 7, 'mac']
    }
  };

  /* dimensions.com ölçülendirilmiş çizimlerden çıkarılan arka yüz geometrisi (mm; orijin cihaz sol-üst).
     island/inner/glass/screen: [x,y,w,h,r]; lenses: [cx,cy,rDış,rHalka,rCam]; dots: [cx,cy,r,tip]; logo: [cx,cy,w,h]. Üretim: dev/build_geo.py */
  var GEO = {"iphone|iphone 17 pro max":{"w":78.0,"h":163.4,"r":12.1,"island":[2,2,74,43.5,10.3],"inner":[4.4,4.4,69.3,38.8,8.2],"lenses":[[32.3,23.8,8.1,7,3.7],[14.4,33.1,8.1,7,3.9],[14.4,14.4,8.1,7,5]],"dots":[[64.1,13.8,3.3,"flash"],[64.1,33.8,3.3,"lidar"],[64.1,23.8,0.8,"mic"]],"logo":[39.0,102.3,16.0,19.6],"glass":[[4,49,70,110.4,8.2]],"screen":null},"iphone|iphone 17 pro":{"w":71.9,"h":150.0,"r":10.8,"island":[2,2,67.9,43.5,10.4],"inner":[4.4,4.4,63.2,38.7,8.2],"lenses":[[14.4,14.4,8.1,7,5],[14.4,33.1,8.1,7,3.8],[32.3,23.8,8.1,7,3.7]],"dots":[[58,13.8,3.3,"flash"],[58,33.8,3.3,"lidar"],[58,23.8,0.8,"mic"]],"logo":[36.0,95.4,16.0,19.6],"glass":[[4,49,63.9,97,7]],"screen":null},"iphone|iphone air":{"w":74.7,"h":156.2,"r":10.8,"island":[1.7,1.4,71.3,28.9,12.5],"inner":[4.4,4.1,66,23.5,9.8],"lenses":[[16.1,15.8,8,6.9,3.6]],"dots":[[59.1,15.8,3.1,"flash"],[52,15.8,0.9,"mic"]],"logo":[37.4,77.8,15.7,19.2],"glass":[],"screen":null},"iphone|iphone 17":{"w":71.5,"h":149.6,"r":10.9,"island":[2,2,22.6,40.3,9.3],"inner":[3.8,3.8,19,36.7,7.8],"lenses":[[13.3,31,8.1,7,3.6],[13.3,13.3,8.1,7,4.5]],"dots":[[30.3,22.2,3,"flash"],[20.2,22.2,0.5,"mic"]],"logo":[35.8,73.1,16.0,19.6],"glass":[],"screen":null},"iphone|iphone 16 pro max":{"w":77.6,"h":163.0,"r":10.7,"island":[2.3,2.3,40.6,41.4,8.8],"inner":[4,4,37.2,38,7.3],"lenses":[[13.3,32.8,8.1,7,3.9],[13.3,13.3,8.1,7,5],[32,23,8.1,7,3.7]],"dots":[[32,9.4,3.5,"flash"],[32,36.6,3.3,"lidar"]],"logo":[38.8,79.6,17.3,21.3],"glass":[],"screen":null},"iphone|iphone 16 pro":{"w":71.5,"h":149.6,"r":10.9,"island":[2.3,2.3,40.6,41.4,8.9],"inner":[4,4,37.2,38,7.3],"lenses":[[32,23,8.1,7,3.7],[13.3,32.8,8.1,7,3.8],[13.3,13.3,8.1,7,5]],"dots":[[32,9.4,3.5,"flash"],[32,36.6,3.3,"lidar"]],"logo":[35.8,73.0,16.4,20.1],"glass":[],"screen":null},"iphone|iphone 16 plus":{"w":77.8,"h":160.9,"r":10,"island":[2.6,2.5,22.5,40,9.3],"inner":[3.8,3.8,20.1,37.6,8.2],"lenses":[[13.8,31.3,8,7.1,3.5],[13.8,13.8,8,7.1,4.5]],"dots":[[30.3,22.6,3.1,"flash"],[20.8,22.6,0.6,"mic"]],"logo":[38.9,78.8,16.9,20.8],"glass":[],"screen":null},"iphone|iphone 16":{"w":71.6,"h":147.6,"r":10,"island":[2.6,2.6,22.5,40,9.3],"inner":[3.8,3.8,20.1,37.6,8.3],"lenses":[[13.8,13.8,8,7.1,4.5],[13.8,31.3,8,7.1,3.5]],"dots":[[30.3,22.6,3.1,"flash"],[20.8,22.6,0.6,"mic"]],"logo":[35.8,72.2,15.7,19.3],"glass":[],"screen":null},"iphone|iphone 16e":{"w":71.5,"h":146.7,"r":10,"island":null,"inner":null,"lenses":[[13.8,13.8,7.2,6.2,3.4]],"dots":[[27.5,13.8,2.6,"flash"]],"logo":[35.8,72.2,15.7,19.3],"glass":[],"screen":null},"iphone|iphone 15 pro max":{"w":76.7,"h":159.9,"r":10.1,"island":[2.3,2.3,40.7,41.4,8.7],"inner":[4,4,37.3,38,7.2],"lenses":[[31.5,23,7.7,6.7,2.6],[13,13,7.7,6.7,5],[13,33,7.7,6.7,3.8]],"dots":[[31.5,9.8,3.2,"flash"],[31.5,37,3.1,"lidar"],[37.3,33.4,0.4,"mic"]],"logo":[38.4,79.7,15.7,19.4],"glass":[],"screen":null},"iphone|iphone 15 pro":{"w":70.6,"h":146.6,"r":10.3,"island":[2.3,2.3,40.6,41.4,8.7],"inner":[4,4,37.2,38,7.3],"lenses":[[31.5,23,7.7,6.7,2.6],[13,13,7.7,6.7,5],[13,33,7.7,6.7,3.8]],"dots":[[31.5,9.8,3.2,"flash"],[31.5,37.1,3.1,"lidar"]],"logo":[35.3,73.3,15.7,19.4],"glass":[],"screen":null},"iphone|iphone 15 plus":{"w":77.8,"h":160.9,"r":9.8,"island":[2.6,2.5,33.4,33.4,8.3],"inner":[3.8,3.8,31,31,7.2],"lenses":[[25.8,25.8,7.4,6.4,3.3],[12.8,12.7,7.4,6.4,3.3]],"dots":[[27.3,11.2,3.2,"flash"],[10.7,26.3,1,"mic"]],"logo":[38.9,77.6,17.1,21.9],"glass":[],"screen":null},"iphone|iphone 15":{"w":71.6,"h":147.6,"r":10,"island":[2.6,2.6,33.4,33.4,8.3],"inner":[3.8,3.8,31,31,7.2],"lenses":[[25.8,25.8,7.4,6.4,3.3],[12.8,12.8,7.4,6.4,3.3]],"dots":[[27.3,11.3,3.2,"flash"],[10.7,26.3,1,"mic"]],"logo":[35.8,71.6,15.7,19.3],"glass":[],"screen":null},"iphone|iphone 14 pro max":{"w":77.6,"h":160.7,"r":10.1,"island":[2.8,2.5,41,42.5,10],"inner":[4.8,4.5,37,38.5,8.1],"lenses":[[14.5,33.4,8.1,6.8,5],[14.5,14.1,8.1,6.8,5],[32.1,23.7,8.1,6.8,5]],"dots":[[32.1,10.2,3.4,"flash"],[32.1,37.5,3.2,"lidar"],[37.9,33.9,0.4,"mic"]],"logo":[38.8,80.4,17.8,21.9],"glass":[],"screen":null},"iphone|iphone 14 pro":{"w":71.5,"h":147.5,"r":10,"island":[2.7,2.5,41,42.5,10],"inner":[4.7,4.5,37,38.5,8.1],"lenses":[[14.4,33.4,8.1,6.8,5],[14.4,14.1,8.1,6.8,5],[32,23.7,8.1,6.8,5]],"dots":[[32,10.2,3.4,"flash"],[32,37.5,3.2,"lidar"],[37.9,33.9,0.4,"mic"]],"logo":[35.8,73.8,16.6,20.4],"glass":[],"screen":null},"iphone|iphone 14 plus":{"w":78.1,"h":160.8,"r":10.1,"island":[1.7,1.8,33.8,33.8,8.8],"inner":[3.5,3.5,30.3,30.3,7.2],"lenses":[[25,25.1,7.5,6.2,3.5],[12.2,12.3,7.5,6.2,3.5]],"dots":[[27.1,10.6,3.2,"flash"],[11.1,26.3,1.2,"mic"]],"logo":[39.0,79.4,15.8,19.5],"glass":[],"screen":null},"iphone|iphone 14":{"w":71.5,"h":146.7,"r":9.3,"island":[1,1,33.7,33.7,8.8],"inner":[2.7,2.7,30.3,30.3,7.3],"lenses":[[24.3,24.2,7.5,6.2,3.5],[11.5,11.4,7.5,6.2,3.5]],"dots":[[26.3,9.8,3.2,"flash"],[10.4,25.5,1.2,"mic"]],"logo":[35.8,71.6,15.3,18.8],"glass":[],"screen":null},"iphone|iphone 13 pro max":{"w":78.1,"h":160.8,"r":10.1,"island":[3.4,3.3,37,38,7.7],"inner":[4.4,4.3,35,36,6.8],"lenses":[[30.1,22.3,7.6,6.4,4.5],[13.4,13.3,7.6,6.4,2.9],[13.4,31.2,7.6,6.4,3.4]],"dots":[[30.1,9.1,3.1,"flash"],[30,35.2,3,"lidar"],[35.8,32.1,0.6,"mic"]],"logo":[39.0,77.6,16.3,20.1],"glass":[],"screen":null},"iphone|iphone 13 pro":{"w":71.5,"h":146.7,"r":9.7,"island":[3.2,3.3,37,38,7.8],"inner":[4.2,4.3,35,36,6.8],"lenses":[[29.9,22.3,7.6,6.4,4.5],[13.2,13.3,7.6,6.4,2.9],[13.2,31.2,7.6,6.4,3.4]],"dots":[[30,9.1,3.1,"flash"],[29.9,35.2,3,"lidar"],[35.6,32.1,0.6,"mic"]],"logo":[35.8,71.1,15.3,18.8],"glass":[],"screen":null},"iphone|iphone 13":{"w":71.5,"h":146.7,"r":9.3,"island":[2.8,2.8,30.3,30.3,7.3],"inner":null,"lenses":[[24.1,24.1,7,5.8,3],[11.8,11.8,7,5.8,3.5]],"dots":[[26,9.9,3.1,"flash"],[10.3,25.6,1.2,"mic"]],"logo":[35.8,72.8,15.3,18.8],"glass":[],"screen":null},"iphone|iphone 13 mini":{"w":64.2,"h":131.5,"r":8.2,"island":[1.7,1.8,30.3,30.3,7.4],"inner":null,"lenses":[[23,23.1,7,5.8,3],[10.7,10.8,7,5.8,3.5]],"dots":[[25,8.8,3.1,"flash"],[9.3,24.5,1.2,"mic"]],"logo":[32.1,63.4,13.7,16.7],"glass":[],"screen":null},"iphone|iphone 12 pro max":{"w":78.1,"h":160.8,"r":9.6,"island":[4.3,4.3,33.2,35.3,7.3],"inner":[5.4,5.4,31,33,6.3],"lenses":[[13.4,13.4,7.1,5.6,1.8],[13.4,30.4,7.1,5.6,1.8],[28.6,21.9,6.9,5.6,2]],"dots":[[28.6,9.8,3.6,"flash"],[28.6,34,3.3,"lidar"],[33.9,30.3,0.8,"mic"]],"logo":[39.0,77.8,16.3,20.0],"glass":[],"screen":null},"iphone|iphone 12 pro":{"w":71.5,"h":146.7,"r":9.5,"island":[4.2,4.3,29.4,31.2,6.3],"inner":[5.2,5.3,27.4,29.2,5.5],"lenses":[[12.4,27.3,6.3,4.9,1.6],[12.4,12.3,6.3,4.9,1.6],[25.7,19.8,6.1,5,1.8]],"dots":[[25.7,9.1,3.2,"flash"],[25.7,30.5,2.9,"lidar"],[30.4,27.3,0.7,"mic"]],"logo":[35.8,70.8,15.1,18.5],"glass":[],"screen":null},"iphone|iphone 12":{"w":71.5,"h":146.7,"r":9.5,"island":[4.2,4.3,29.4,31.2,6.3],"inner":[5.6,5.7,26.6,28.4,5.1],"lenses":[[13,12.7,6,4.7,1.6],[13,26.9,6,4.7,1.6]],"dots":[[25.6,19.8,2.6,"flash"],[25.6,12.2,1.1,"mic"]],"logo":[35.8,70.8,15.1,18.5],"glass":[],"screen":null},"iphone|iphone 12 mini":{"w":64.2,"h":131.5,"r":8.8,"island":[2.2,2.2,28.2,31.2,6.3],"inner":[3.6,3.6,25.4,28.4,5.1],"lenses":[[10.9,10.7,6,4.7,1.6],[10.9,24.9,6,4.7,1.6]],"dots":[[22.4,17.8,2.6,"flash"],[22.4,10.2,1.1,"mic"]],"logo":[32.1,63.4,13.7,16.7],"glass":[],"screen":null},"iphone|iphone 11":{"w":75.7,"h":150.9,"r":10.3,"island":[4.4,4.4,27.5,30.5,6.3],"inner":[5.4,5.4,25.5,28.5,5.4],"lenses":[[12.3,27,6.2,5.2,2.8],[12.3,12.3,6.2,5.2,2.8]],"dots":[[24.1,19.7,2.6,"flash"],[24.1,12.3,1.2,"mic"]],"logo":[37.8,73.2,14.0,17.2],"glass":[],"screen":null},"samsung|galaxy s26 ultra":{"w":78.1,"h":163.4,"r":3.0,"island":null,"inner":null,"lenses":[[14.8,12.1,6.9,6.2,1.7],[14.8,29.1,6.9,6.2,1.7],[14.8,46.1,6.9,6.2,3.2],[30.5,29.1,4.7,4.1,1.2],[30.5,11.5,4.7,4.1,2.1]],"dots":[[30.5,20.1,1.9,"mic"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy s26":{"w":70.5,"h":146.9,"r":7.5,"island":null,"inner":null,"lenses":[[11.5,25.8,6.1,5.5,1.8],[11.5,11.3,6.1,5.5,1.3],[11.5,40.2,6.1,5.5,1.8]],"dots":[[27.3,11.3,2.2,"flash"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy s25 ultra":{"w":77.6,"h":162.8,"r":3.0,"island":null,"inner":null,"lenses":[[14.8,12.1,6.9,6.2,1.7],[14.8,29.1,6.9,6.2,1.7],[14.8,46.1,6.9,6.2,3.2],[30.5,29.1,4.7,4.1,1.2],[30.5,11.5,4.7,4.1,2.1]],"dots":[[30.5,20.1,1.9,"mic"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy s25 plus":{"w":75.8,"h":158.4,"r":8.5,"island":null,"inner":null,"lenses":[[12.3,26.3,6.3,5.1,1.7],[12.3,12,6.3,5.1,1.7],[12.3,40.7,6.3,5.1,1.7]],"dots":[[27.9,12,2.3,"flash"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy s25":{"w":70.5,"h":146.9,"r":7.5,"island":null,"inner":null,"lenses":[[11.5,25.8,6.1,5.5,1.8],[11.5,11.3,6.1,5.5,1.3],[11.5,40.2,6.1,5.5,1.8]],"dots":[[27.3,11.3,2.2,"flash"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy s24 ultra":{"w":79.0,"h":162.3,"r":3.0,"island":null,"inner":null,"lenses":[[14.8,12.1,6.9,6.2,1.7],[14.8,29.1,6.9,6.2,1.7],[14.8,46.1,6.9,6.2,3.2],[30.5,29.1,4.7,4.1,1.2],[30.5,11.5,4.7,4.1,2.1]],"dots":[[30.5,20.1,1.9,"mic"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy s24 plus":{"w":75.9,"h":158.5,"r":8.5,"island":null,"inner":null,"lenses":[[12.3,26.3,6.3,5.1,1.7],[12.3,12,6.3,5.1,1.7],[12.3,40.7,6.3,5.1,1.7]],"dots":[[27.9,12,2.3,"flash"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy s24":{"w":70.6,"h":147.0,"r":7.5,"island":null,"inner":null,"lenses":[[11.5,25.8,6.1,5.5,1.8],[11.5,11.3,6.1,5.5,1.3],[11.5,40.2,6.1,5.5,1.8]],"dots":[[27.3,11.3,2.2,"flash"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy s24 fe":{"w":77.3,"h":162.0,"r":8.5,"island":null,"inner":null,"lenses":[[12.3,26.3,6.3,5.1,1.7],[12.3,12,6.3,5.1,1.7],[12.3,40.7,6.3,5.1,1.7]],"dots":[[27.9,12,2.3,"flash"]],"logo":null,"glass":[[1.8,1.8,72.3,153.8,6.8]],"screen":null},"samsung|galaxy s23 ultra":{"w":78.1,"h":163.4,"r":3.0,"island":null,"inner":null,"lenses":[[14.8,12.1,6.9,6.2,1.7],[14.8,29.1,6.9,6.2,1.7],[14.8,46.1,6.9,6.2,3.2],[30.5,29.1,4.7,4.1,1.2],[30.5,11.5,4.7,4.1,2.1]],"dots":[[30.5,20.1,1.9,"mic"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy s23 plus":{"w":76.2,"h":157.8,"r":8.5,"island":null,"inner":null,"lenses":[[12.3,26.3,6.3,5.1,1.7],[12.3,12,6.3,5.1,1.7],[12.3,40.7,6.3,5.1,1.7]],"dots":[[27.9,12,2.3,"flash"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy s23":{"w":70.9,"h":146.3,"r":7.5,"island":null,"inner":null,"lenses":[[11.5,25.8,6.1,5.5,1.8],[11.5,11.3,6.1,5.5,1.3],[11.5,40.2,6.1,5.5,1.8]],"dots":[[27.3,11.3,2.2,"flash"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy s23 fe":{"w":76.5,"h":158.0,"r":7.5,"island":null,"inner":null,"lenses":[[11.5,25.8,6.1,5.5,1.8],[11.5,11.3,6.1,5.5,1.3],[11.5,40.2,6.1,5.5,1.8]],"dots":[[27.3,11.3,2.2,"flash"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy s22 ultra":{"w":77.9,"h":163.3,"r":3.0,"island":null,"inner":null,"lenses":[[14.8,12.1,6.9,6.2,1.7],[14.8,29.1,6.9,6.2,1.7],[14.8,46.1,6.9,6.2,3.2],[30.5,29.1,4.7,4.1,1.2],[30.5,11.5,4.7,4.1,2.1]],"dots":[[30.5,20.1,1.9,"mic"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy s22 plus":{"w":75.8,"h":157.4,"r":8.5,"island":[1.8,1.8,21,49,10.5],"inner":null,"lenses":[[12.3,26.3,6.3,5.1,1.7],[12.3,12,6.3,5.1,1.7],[12.3,40.7,6.3,5.1,1.7]],"dots":[[27.9,12,2.3,"flash"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy s22":{"w":70.6,"h":146.0,"r":7.5,"island":[1,1,21.5,49.5,10.8],"inner":null,"lenses":[[11.5,25.8,6.1,5.5,1.8],[11.5,11.3,6.1,5.5,1.3],[11.5,40.2,6.1,5.5,1.8]],"dots":[[27.3,11.3,2.2,"flash"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy s21 ultra":{"w":75.6,"h":165.1,"r":3.0,"island":null,"inner":null,"lenses":[[14.8,12.1,6.9,6.2,1.7],[14.8,29.1,6.9,6.2,1.7],[14.8,46.1,6.9,6.2,3.2],[30.5,29.1,4.7,4.1,1.2],[30.5,11.5,4.7,4.1,2.1]],"dots":[[30.5,20.1,1.9,"mic"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy s21":{"w":71.2,"h":151.7,"r":7.5,"island":[1,1,21.5,49.5,10.8],"inner":null,"lenses":[[11.5,25.8,6.1,5.5,1.8],[11.5,11.3,6.1,5.5,1.3],[11.5,40.2,6.1,5.5,1.8]],"dots":[[27.3,11.3,2.2,"flash"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy s21 fe":{"w":74.5,"h":155.7,"r":7.5,"island":null,"inner":null,"lenses":[[11.5,25.8,6.1,5.5,1.8],[11.5,11.3,6.1,5.5,1.3],[11.5,40.2,6.1,5.5,1.8]],"dots":[[27.3,11.3,2.2,"flash"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy a73 5g":{"w":76.1,"h":163.7,"r":6.3,"island":[4.4,3.9,30.5,46.8,7.4],"inner":[6.4,5.9,26.5,42.7,5.6],"lenses":[[14.4,27.3,5.7,4.7,1.6],[14.4,14,5.7,4.7,1.6],[14.4,40.9,5.7,4.7,0.6],[26.5,34.3,3.6,1.9,1.6],[26.5,20.6,3.6,1.9,0.6]],"dots":[[40.4,13.5,2.0,"flash"]],"logo":null,"glass":[[1.4,1.3,72.1,156.9,5.1]],"screen":null},"samsung|galaxy a55 5g":{"w":77.4,"h":161.1,"r":6.3,"island":null,"inner":null,"lenses":[[14.4,27.3,5.7,4.7,1.6],[14.4,14,5.7,4.7,1.6],[14.4,40.9,5.7,4.7,0.6]],"dots":[[26.5,13.5,2.0,"flash"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy a54 5g":{"w":76.7,"h":158.2,"r":6.3,"island":null,"inner":null,"lenses":[[14.4,27.3,5.7,4.7,1.6],[14.4,14,5.7,4.7,1.6],[14.4,40.9,5.7,4.7,0.6]],"dots":[[26.5,13.5,2.0,"flash"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy a53 5g":{"w":74.8,"h":159.6,"r":6.3,"island":[4.4,3.9,30.5,46.8,7.4],"inner":[6.4,5.9,26.5,42.7,5.6],"lenses":[[14.4,27.3,5.7,4.7,1.6],[14.4,14,5.7,4.7,1.6],[14.4,40.9,5.7,4.7,0.6],[26.5,34.3,3.6,1.9,1.6],[26.5,20.6,3.6,1.9,0.6]],"dots":[[40.4,13.5,2.0,"flash"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy a35 5g":{"w":78.0,"h":161.7,"r":6.3,"island":null,"inner":null,"lenses":[[14.4,27.3,5.7,4.7,1.6],[14.4,14,5.7,4.7,1.6],[14.4,40.9,5.7,4.7,0.6]],"dots":[[26.5,13.5,2.0,"flash"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy a34 5g":{"w":78.1,"h":161.3,"r":6.3,"island":null,"inner":null,"lenses":[[14.4,27.3,5.7,4.7,1.6],[14.4,14,5.7,4.7,1.6],[14.4,40.9,5.7,4.7,0.6]],"dots":[[26.5,13.5,2.0,"flash"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy a33 5g":{"w":74.0,"h":159.7,"r":6.3,"island":[4.4,3.9,30.5,46.8,7.4],"inner":[6.4,5.9,26.5,42.7,5.6],"lenses":[[14.4,27.3,5.7,4.7,1.6],[14.4,14,5.7,4.7,1.6],[14.4,40.9,5.7,4.7,0.6],[26.5,34.3,3.6,1.9,1.6],[26.5,20.6,3.6,1.9,0.6]],"dots":[[40.4,13.5,2.0,"flash"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy a25 5g":{"w":76.5,"h":161.0,"r":6.3,"island":null,"inner":null,"lenses":[[14.4,27.3,5.7,4.7,1.6],[14.4,14,5.7,4.7,1.6],[14.4,40.9,5.7,4.7,0.6]],"dots":[[26.5,13.5,2.0,"flash"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy a24":{"w":77.6,"h":162.1,"r":6.3,"island":null,"inner":null,"lenses":[[14.4,27.3,5.7,4.7,1.6],[14.4,14,5.7,4.7,1.6],[14.4,40.9,5.7,4.7,0.6]],"dots":[[26.5,13.5,2.0,"flash"]],"logo":null,"glass":[[1.4,1.3,72.1,156.9,5.1]],"screen":null},"samsung|galaxy a23":{"w":76.9,"h":165.4,"r":6.3,"island":[4.4,3.9,30.5,46.8,7.4],"inner":[6.4,5.9,26.5,42.7,5.6],"lenses":[[14.4,27.3,5.7,4.7,1.6],[14.4,14,5.7,4.7,1.6],[14.4,40.9,5.7,4.7,0.6],[26.5,34.3,3.6,1.9,1.6],[26.5,20.6,3.6,1.9,0.6]],"dots":[[40.4,13.5,2.0,"flash"]],"logo":null,"glass":[[1.4,1.3,72.1,156.9,5.1]],"screen":null},"samsung|galaxy z fold 7":{"w":72.8,"h":158.4,"r":6.3,"island":[7.5,6.6,17.5,53.5,6.8],"inner":null,"lenses":[[16.3,15.3,6.6,5.3,1.8],[16.3,29.4,6.6,5.3,1.8],[16.3,43.6,6.6,5.3,1.8]],"dots":[[16.3,53.9,2,"flash"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy z flip 7":{"w":75.2,"h":85.5,"r":7.9,"island":null,"inner":null,"lenses":[[13,25.4,5.5,4.2,1.5],[13,12.1,5.5,4.2,1.5]],"dots":[[13,38.1,1.7,"mic"]],"logo":null,"glass":[],"screen":[3,3,69.2,79.5,6]},"samsung|galaxy z fold 6":{"w":68.1,"h":153.5,"r":6.3,"island":[7.5,6.6,17.5,53.5,6.8],"inner":null,"lenses":[[16.3,15.3,6.6,5.3,1.8],[16.3,29.4,6.6,5.3,1.8],[16.3,43.6,6.6,5.3,1.8]],"dots":[[16.3,53.9,2,"flash"]],"logo":null,"glass":[],"screen":null},"samsung|galaxy z flip 6":{"w":71.9,"h":85.1,"r":7.9,"island":null,"inner":null,"lenses":[[13,25.4,5.5,4.2,1.5],[13,12.1,5.5,4.2,1.5]],"dots":[[13,38.1,1.7,"mic"]],"logo":null,"glass":[],"screen":[26,4,41.900000000000006,77.1,4]},"ipad|ipad air 13 (m3) 2025":{"w":214.9,"h":280.6,"r":8.0,"island":null,"inner":null,"lenses":[[13,13,6,5.2,2]],"dots":[[13,27.9,1.3,"mic"]],"logo":[107.4,115.6,28.3,34.8],"glass":[],"screen":null},"ipad|ipad air 11 (m3) 2025":{"w":178.5,"h":247.6,"r":8.0,"island":null,"inner":null,"lenses":[[13,13,6,5.2,2]],"dots":[[13,27.9,1.3,"mic"]],"logo":[89.2,115.6,28.3,34.8],"glass":[],"screen":null},"ipad|ipad 11 (a16) 2025":{"w":179.5,"h":248.6,"r":8.0,"island":null,"inner":null,"lenses":[[13,13,6,5.2,2]],"dots":[[13,27.9,1.3,"mic"]],"logo":[89.8,115.6,28.3,34.8],"glass":[],"screen":null},"ipad|ipad pro 13 m4 2024":{"w":215.5,"h":281.6,"r":8.0,"island":[7,7,26,26,6.5],"inner":null,"lenses":[[15.3,15.6,5.8,5,1.8]],"dots":[[15.3,25.7,4.2,"lidar"],[25.7,20,2.6,"flash"],[25.7,12.7,1.2,"mic"]],"logo":[107.8,113.7,28.9,35.4],"glass":[],"screen":null},"ipad|ipad pro 11 m4 2024":{"w":177.5,"h":249.7,"r":8.0,"island":[7,7,26,26,6.5],"inner":null,"lenses":[[15.3,15.6,5.8,5,1.8]],"dots":[[15.3,25.7,4.2,"lidar"],[25.7,20,2.6,"flash"],[25.7,12.7,1.2,"mic"]],"logo":[88.8,113.7,28.9,35.4],"glass":[],"screen":null},"ipad|ipad air 13 (m2) 2024":{"w":214.9,"h":280.6,"r":8.0,"island":null,"inner":null,"lenses":[[13,13,6,5.2,2]],"dots":[[13,27.9,1.3,"mic"]],"logo":[107.4,115.6,28.3,34.8],"glass":[],"screen":null},"ipad|ipad air 11 (m2) 2024":{"w":178.5,"h":247.6,"r":8.0,"island":null,"inner":null,"lenses":[[13,13,6,5.2,2]],"dots":[[13,27.9,1.3,"mic"]],"logo":[89.2,115.6,28.3,34.8],"glass":[],"screen":null},"ipad|ipad pro 12.9 m2 2022":{"w":214.9,"h":280.6,"r":8.0,"island":[7,7,32.4,30.4,6.1],"inner":[7.9,7.9,30.6,28.6,5.3],"lenses":[[15.9,29.1,6,5.2,1.1],[15.9,15.3,6,5.2,1.6]],"dots":[[31.5,22.2,4.2,"lidar"],[31.5,13,2.2,"flash"],[31.5,31.3,1.3,"mic"]],"logo":[107.4,134.7,29.3,36.0],"glass":[],"screen":null},"ipad|ipad pro 11 m2 2022":{"w":178.5,"h":247.6,"r":8.0,"island":[6,6,26.9,26.9,4.9],"inner":[6.8,6.8,25.2,25.2,4.1],"lenses":[[13.5,25.5,5.1,4.3,1],[13.5,13.4,5.1,4.3,1.3]],"dots":[[26.3,19.5,3.6,"lidar"],[26.3,11.4,1.9,"mic"],[26.3,27.4,1.2,"mic"]],"logo":[89.2,113.7,28.9,35.4],"glass":[],"screen":null},"ipad|ipad 10.9 2022":{"w":179.5,"h":248.6,"r":8.0,"island":null,"inner":null,"lenses":[[13,13,6,5.2,2]],"dots":[[13,27.9,1.3,"mic"]],"logo":[89.8,115.6,28.3,34.8],"glass":[],"screen":null},"ipad|ipad air 2020/2022":{"w":178.5,"h":247.6,"r":8.0,"island":null,"inner":null,"lenses":[[13,13,6,5.2,2]],"dots":[[13,27.9,1.3,"mic"]],"logo":[89.2,115.6,28.3,34.8],"glass":[],"screen":null},"ipad|ipad pro 12.9 m1 2021":{"w":214.9,"h":280.6,"r":8.0,"island":[7,7,32.4,30.4,6.1],"inner":[7.9,7.9,30.6,28.6,5.3],"lenses":[[15.9,29.1,6,5.2,1.1],[15.9,15.3,6,5.2,1.6]],"dots":[[31.5,22.2,4.2,"lidar"],[31.5,13,2.2,"flash"],[31.5,31.3,1.3,"mic"]],"logo":[107.4,134.7,29.3,36.0],"glass":[],"screen":null},"ipad|ipad pro 11 m1 2021":{"w":178.5,"h":247.6,"r":8.0,"island":[6,6,26.9,26.9,4.9],"inner":[6.8,6.8,25.2,25.2,4.1],"lenses":[[13.5,25.5,5.1,4.3,1],[13.5,13.4,5.1,4.3,1.3]],"dots":[[26.3,19.5,3.6,"lidar"],[26.3,11.4,1.9,"mic"],[26.3,27.4,1.2,"mic"]],"logo":[89.2,113.7,28.9,35.4],"glass":[],"screen":null},"ipad|ipad 10.2 2021":{"w":174.1,"h":250.6,"r":7.6,"island":null,"inner":null,"lenses":[],"dots":[[14.2,11.3,3.2,"flash"]],"logo":[87.0,123.6,27.8,34.2],"glass":[],"screen":null},"ipad|ipad mini 6 2021":{"w":134.8,"h":195.4,"r":10.5,"island":null,"inner":null,"lenses":[[12.5,12.5,6,5.3,1.8]],"dots":[[12.5,27.4,1.8,"mic"],[12.5,22.3,0.5,"mic"]],"logo":[67.4,95.1,25.5,31.4],"glass":[],"screen":null},"ipad|ipad pro 12.9 2020":{"w":214.9,"h":280.6,"r":8.0,"island":[7,7,32.4,30.4,6.1],"inner":[7.9,7.9,30.6,28.6,5.3],"lenses":[[15.9,29.1,6,5.2,1.1],[15.9,15.3,6,5.2,1.6]],"dots":[[31.5,22.2,4.2,"lidar"],[31.5,13,2.2,"flash"],[31.5,31.3,1.3,"mic"]],"logo":[107.4,134.7,29.3,36.0],"glass":[],"screen":null},"ipad|ipad pro 11 2020":{"w":178.5,"h":247.6,"r":8.0,"island":[6,6,26.9,26.9,4.9],"inner":[6.8,6.8,25.2,25.2,4.1],"lenses":[[13.5,25.5,5.1,4.3,1],[13.5,13.4,5.1,4.3,1.3]],"dots":[[26.3,19.5,3.6,"lidar"],[26.3,11.4,1.9,"mic"],[26.3,27.4,1.2,"mic"]],"logo":[89.2,113.7,28.9,35.4],"glass":[],"screen":null},"ipad|ipad 10.2 2020":{"w":174.1,"h":250.6,"r":7.6,"island":null,"inner":null,"lenses":[],"dots":[[14.2,11.3,3.2,"flash"]],"logo":[87.0,123.6,27.8,34.2],"glass":[],"screen":null},"macbook|macbook pro 16 m5":{"w":355.7,"h":248.1,"r":7.3,"island":null,"inner":null,"lenses":[],"dots":[],"logo":[177.8,120.6,38.0,46.6],"glass":[],"screen":null},"macbook|macbook pro 14 m5":{"w":312.6,"h":221.2,"r":7.6,"island":null,"inner":null,"lenses":[],"dots":[],"logo":[156.3,107.1,38.0,46.6],"glass":[],"screen":null},"macbook|macbook neo":{"w":304.0,"h":212.0,"r":8.1,"island":null,"inner":null,"lenses":[],"dots":[],"logo":[152.0,102.5,37.0,45.4],"glass":[],"screen":null},"macbook|macbook pro 16 m1 | m2 | m3 | m4":{"w":355.7,"h":248.1,"r":7.3,"island":null,"inner":null,"lenses":[],"dots":[],"logo":[177.8,120.6,38.0,46.6],"glass":[],"screen":null},"macbook|macbook pro 14 m1 | m2 | m3 | m4":{"w":312.6,"h":221.2,"r":7.6,"island":null,"inner":null,"lenses":[],"dots":[],"logo":[156.3,107.1,38.0,46.6],"glass":[],"screen":null},"macbook|macbook air 15 m4 (2025)":{"w":340.4,"h":237.6,"r":8.1,"island":null,"inner":null,"lenses":[],"dots":[],"logo":[170.2,115.3,37.0,45.4],"glass":[],"screen":null},"macbook|macbook air 13 m4 (2025)":{"w":304.1,"h":215.0,"r":8.1,"island":null,"inner":null,"lenses":[],"dots":[],"logo":[152.0,104.0,37.0,45.4],"glass":[],"screen":null},"macbook|macbook air 15 m2 | m3":{"w":340.4,"h":237.6,"r":8.1,"island":null,"inner":null,"lenses":[],"dots":[],"logo":[170.2,115.3,37.0,45.4],"glass":[],"screen":null},"macbook|macbook air 13.6 m2 | m3":{"w":304.1,"h":215.0,"r":8.1,"island":null,"inner":null,"lenses":[],"dots":[],"logo":[152.0,104.0,37.0,45.4],"glass":[],"screen":null},"macbook|macbook air 13 m1 (2020)":{"w":304.1,"h":212.4,"r":8.1,"island":null,"inner":null,"lenses":[],"dots":[],"logo":[152.0,102.7,37.0,45.4],"glass":[],"screen":null},"macbook|macbook air 13 (2020)":{"w":304.1,"h":212.4,"r":8.1,"island":null,"inner":null,"lenses":[],"dots":[],"logo":[152.0,102.7,37.0,45.4],"glass":[],"screen":null},"macbook|macbook pro 16 (2019)":{"w":357.9,"h":245.9,"r":7.3,"island":null,"inner":null,"lenses":[],"dots":[],"logo":[179.0,119.4,38.0,46.6],"glass":[],"screen":null},"macbook|macbook pro 15 (2018 - 2019)":{"w":349.3,"h":240.7,"r":7.3,"island":null,"inner":null,"lenses":[],"dots":[],"logo":[174.6,116.8,38.0,46.6],"glass":[],"screen":null},"macbook|macbook pro 13 (2018)":{"w":304.1,"h":212.4,"r":7.6,"island":null,"inner":null,"lenses":[],"dots":[],"logo":[152.0,102.7,38.0,46.6],"glass":[],"screen":null},"macbook|macbook air 13 (2018)":{"w":304.1,"h":212.4,"r":8.1,"island":null,"inner":null,"lenses":[],"dots":[],"logo":[152.0,102.7,37.0,45.4],"glass":[],"screen":null}};

  var SURFACE_LABELS = { back: 'Arka Yüz', top: 'Üst Kapak', bottom: 'Alt Kapak' };

  /* ------------------------------ yardımcılar ----------------------------- */
  function norm(s) { return String(s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { el.addEventListener(ev, fn, opts || false); }
  function slug(s) { return norm(s).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }

  function roundRect(ctx, x, y, w, h, r) {
    r = Math.min(r, w / 2, h / 2);
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  function canvasToBlob(canvas, type, quality) {
    return new Promise(function (resolve, reject) {
      if (canvas.toBlob) {
        canvas.toBlob(function (b) { b ? resolve(b) : reject(new Error('toBlob failed')); }, type, quality);
      } else {
        try {
          var dataUrl = canvas.toDataURL(type, quality);
          var bin = atob(dataUrl.split(',')[1]);
          var arr = new Uint8Array(bin.length);
          for (var i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
          resolve(new Blob([arr], { type: type }));
        } catch (e) { reject(e); }
      }
    });
  }

  function loadImage(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('image load failed')); };
      img.src = src;
    });
  }

  // Kesin eşleşme (boşluk/parantez toleranslı). Bulunamazsa kategori varsayılanı + known:false;
  // tahmini önek eşleşmesi yapılmaz (iPhone 11 Pro → iPhone 11 gibi sessiz hatalara yol açıyordu).
  function findDevice(category, model) {
    if (category === 'artframe') { var f = DEVICES.artframe['50 x 70 cm']; return { w: f[0], h: f[1], r: 0, cam: 'frame', known: true, geo: null }; }
    var table = DEVICES[category] || {};
    var key = norm(model);
    var hit = key ? table[key] : null, hitKey = key;
    if (!hit && key) {
      var loose = function (k) { return k.replace(/[()|]/g, ' ').replace(/\s+/g, ' ').trim(); };
      var lk = loose(key), keys = Object.keys(table);
      for (var i = 0; i < keys.length; i++) if (loose(keys[i]) === lk) { hit = table[keys[i]]; hitKey = keys[i]; break; }
    }
    if (!hit && key) console.warn('[stickidy] ölçü tablosunda yok, kategori varsayılanı kullanılıyor:', model);
    var d = hit || CATEGORY_DEFAULTS[category] || CATEGORY_DEFAULTS.iphone;
    var geo = hit ? (GEO[category + '|' + (table[key] ? key : hitKey)] || null) : null;
    return { w: d[0], h: d[1], r: geo && geo.r ? geo.r : d[2], cam: d[3], known: !!hit, geo: geo };
  }

  // JPEG'in JFIF başlığına dpi yaz (baskıcı dosyayı doğru ölçekte açsın). Başlık yoksa dokunmaz.
  function setJpegDpi(blob, dpi) {
    return blob.slice(0, 32).arrayBuffer().then(function (buf) {
      var b = new Uint8Array(buf);
      if (b[0] !== 0xFF || b[1] !== 0xD8 || b[2] !== 0xFF || b[3] !== 0xE0 || b[6] !== 0x4A || b[7] !== 0x46 || b[8] !== 0x49 || b[9] !== 0x46) return blob;
      var head = new Uint8Array(b.subarray(0, 18));
      head[13] = 1; head[14] = (dpi >> 8) & 0xFF; head[15] = dpi & 0xFF; head[16] = (dpi >> 8) & 0xFF; head[17] = dpi & 0xFF;
      return new Blob([head, blob.slice(18)], { type: 'image/jpeg' });
    }).catch(function () { return blob; });
  }

  function surfacesFor(category, option2) {
    if (category !== 'macbook') return ['back'];
    var o = norm(option2);
    if (o.indexOf('tam') === 0 || o.indexOf('full') === 0) return ['top', 'bottom'];
    if (o.indexOf('alt') === 0 || o.indexOf('bottom') === 0) return ['bottom'];
    return ['top'];
  }

  /* --------------------------- Apple logo (mockup) ------------------------ */
  // Gerçek Apple silüeti (24x24 SVG path, simple-icons). Path2D ile çizilir.
  var APPLE_SVG = 'M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701';
  var APPLE_PATH = null;
  function drawAppleLogo(ctx, cx, cy, height, fill, stroke) {
    var s = height / 24;
    ctx.save();
    ctx.translate(cx - 12.2 * s, cy - 12 * s);
    ctx.scale(s, s);
    if (!APPLE_PATH && typeof Path2D === 'function') { try { APPLE_PATH = new Path2D(APPLE_SVG); } catch (e) { APPLE_PATH = null; } }
    if (APPLE_PATH) {
      ctx.fillStyle = fill; ctx.fill(APPLE_PATH);
      if (stroke) { ctx.strokeStyle = stroke; ctx.lineWidth = 0.25 / s; ctx.lineJoin = 'round'; ctx.stroke(APPLE_PATH); }
    } else {
      // Path2D yoksa sade yedek: elips gövde + yaprak
      ctx.fillStyle = fill; ctx.beginPath(); ctx.ellipse(12, 14, 8.5, 9, 0, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.ellipse(15, 3, 2.2, 3.5, -0.6, 0, Math.PI * 2); ctx.fill();
    }
    ctx.restore();
  }

  /* ============================== ana sınıf ============================== */
  function StickidyCustomizer(root) {
    this.root = root;
    this.category = root.getAttribute('data-category') || 'iphone';
    this.dpi = parseInt(root.getAttribute('data-dpi'), 10) || 300;
    this.bleed = parseFloat(root.getAttribute('data-bleed')); if (isNaN(this.bleed)) this.bleed = 3;
    this.cartUrl = root.getAttribute('data-cart-url') || '/cart/add.js';

    this.product = this.readJSON('[data-stk-product]') || { variants: [], options: [] };
    this.mockups = this.readJSON('[data-stk-mockups]') || [];
    this.strings = this.readJSON('[data-stk-strings]') || {};

    this.canvas = $(root, '[data-stk-canvas]');
    this.ctx = this.canvas.getContext('2d');
    this.wrap = $(root, '[data-stk-stage]');
    this.fileInput = $(root, '[data-stk-file]');

    this.frameColor = FRAME_COLORS[0]; // Art Frame: seçili çerçeve rengi
    this.view = 'front';               // Art Frame: front | angle | corner | wall
    this.layers = {};          // surface -> layer
    this.activeSurface = 'back';
    this.pointers = new Map();
    this.gesture = null;
    this.busy = false;
    this.mockupCache = {};

    this.buildOptions();
    this.bindUI();
    this.bindCanvas();
    this.bindMobileLayout();
    if (this.category === 'artframe') this.bindArtFrame();
    this.syncVariant();
    this.resize();

    var self = this;
    if (window.ResizeObserver) {
      new ResizeObserver(function () { self.resize(); }).observe(this.wrap);
    } else {
      on(window, 'resize', function () { self.resize(); });
    }
    root.classList.add('is-ready');
  }

  var P = StickidyCustomizer.prototype;

  P.t = function (key, fallback) { return this.strings[key] || fallback; };

  P.readJSON = function (sel) {
    var el = $(this.root, sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { console.warn('[stickidy] JSON parse', sel, e); return null; }
  };

  /* ------------------------------ varyantlar ------------------------------ */
  P.buildOptions = function () {
    var self = this;
    this.selects = $$(this.root, '[data-stk-option]');
    var opts = this.product.options || [];
    this.selects.forEach(function (sel) {
      var pos = parseInt(sel.getAttribute('data-stk-option'), 10);
      var key = 'option' + pos;
      var values = [];
      (self.product.variants || []).forEach(function (v) { if (v[key] && values.indexOf(v[key]) < 0) values.push(v[key]); });
      if (!values.length) { sel.innerHTML = ''; var wrap = sel.closest('.stk-cz__select-wrap') || sel; wrap.hidden = true; return; } // adımı değil, yalnızca bu seçiciyi gizle
      var current = sel.value;
      sel.innerHTML = '';
      values.forEach(function (val) {
        var anyAvail = (self.product.variants || []).some(function (v) { return v[key] === val && v.available !== false; });
        var o = document.createElement('option'); o.value = val; o.textContent = val + (anyAvail ? '' : ' (tükendi)'); o.disabled = !anyAvail; sel.appendChild(o);
      });
      var selectedVariant = self.findVariantById(self.product.selected);
      sel.value = (selectedVariant && selectedVariant[key]) || current || values[0];
      on(sel, 'change', function () { self.syncVariant(); });
    });
  };

  P.findVariantById = function (id) {
    var vs = this.product.variants || [];
    for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === String(id)) return vs[i];
    return null;
  };

  P.currentVariant = function () {
    var self = this;
    var vs = this.product.variants || [];
    var match = null;
    for (var i = 0; i < vs.length; i++) {
      var ok = true;
      self.selects.forEach(function (sel) {
        var pos = sel.getAttribute('data-stk-option');
        if (!sel.options.length) return; // ürün bu seçeneği kullanmıyor
        if (vs[i]['option' + pos] !== sel.value) ok = false;
      });
      if (ok) { match = vs[i]; break; }
    }
    return match || vs[0] || null;
  };

  P.syncVariant = function () {
    var v = this.currentVariant();
    this.variant = v;
    var model = v ? v.option1 : '';

    // option2 seçeneklerini option1'e göre daralt (yüzeyler bundan SONRA hesaplanır)
    var self = this;
    if (this.selects.length > 1) {
      var s2 = this.selects[1];
      var allowed = [];
      (this.product.variants || []).forEach(function (x) { if (x.option1 === model && allowed.indexOf(x.option2) < 0) allowed.push(x.option2); });
      $$(s2, 'option').forEach(function (o) { o.hidden = allowed.indexOf(o.value) < 0; o.disabled = o.hidden; });
      if (allowed.length && allowed.indexOf(s2.value) < 0) { s2.value = allowed[0]; this.variant = v = this.currentVariant(); }
    }
    this.surfaces = surfacesFor(this.category, v ? v.option2 : '');
    if (this.surfaces.indexOf(this.activeSurface) < 0) this.activeSurface = this.surfaces[0];
    this.preloadMockups(model);
    this.device = this.deviceFor(this.activeSurface);

    // fiyat
    var priceEl = $(this.root, '[data-stk-price]');
    var cmpEl = $(this.root, '[data-stk-compare]');
    if (priceEl && v) priceEl.innerHTML = v.price_html || (v.price / 100).toFixed(2);
    if (cmpEl) {
      var hasCmp = v && v.compare_at_price && v.compare_at_price > v.price;
      cmpEl.hidden = !hasCmp;
      if (hasCmp) cmpEl.innerHTML = v.compare_at_price_html || (v.compare_at_price / 100).toFixed(2);
    }
    $$(this.root, '[data-stk-price-mirror]').forEach(function (el) { if (v) el.innerHTML = v.price_html || ''; });

    // seçilen model + aktif yüzey için mockup bloğu
    this.mockup = this.findMockup(model, this.activeSurface);

    // katmanları yeni ölçüye uydur (cover oranını koru) — her yüzey kendi cihaz ölçüsüyle
    Object.keys(this.layers).forEach(function (k) {
      var L = self.layers[k];
      L.scale = self.coverScaleFor(L, self.deviceFor(k)) * (L.zoomRel || 1);
    });

    this.renderSurfaceTabs();
    if (this.category === 'artframe') this.paintSurfaceCards();
    this.loadMockupImage();
    this.updateControls();
    this.updateQuality();
    this.resize();
    this.updateCTA();
  };

  // Yüzeye göre cihaz ölçüsü: tablo değeri, blok ayarında mm varsa onunla ezilir
  P.deviceFor = function (surface) {
    var model = this.variant ? this.variant.option1 : '';
    var d = findDevice(this.category, model);
    var m = this.findMockup(model, surface);
    if (m && m.width_mm > 0 && m.height_mm > 0) d = { w: m.width_mm, h: m.height_mm, r: m.radius_mm || d.r, cam: 'none', known: true };
    return d;
  };

  // Tüm yüzeylerin mockup görsellerini önbelleğe al (önizleme/baskı diğer yüzeyi de çizer)
  P.preloadMockups = function (model) {
    var self = this;
    (this.surfaces || []).forEach(function (s) {
      var m = self.findMockup(model, s);
      if (m && m.image && !self.mockupCache[m.image]) loadImage(m.image).then(function (img) { self.mockupCache[m.image] = img; if (self.mockup && self.mockup.image === m.image) { self.mockupImg = img; self.resize(); } }).catch(function () { /* yoksay */ });
    });
  };

  // Aktif yüzeyi geçici olarak değiştir (mockup + cihaz dahil); dönen fonksiyon eski hâle getirir
  P.useSurface = function (surface) {
    var self = this, keep = { s: this.activeSurface, m: this.mockup, mi: this.mockupImg, d: this.device };
    this.activeSurface = surface;
    this.mockup = this.findMockup(this.variant ? this.variant.option1 : '', surface);
    this.mockupImg = this.mockup && this.mockup.image ? (this.mockupCache[this.mockup.image] || null) : null;
    this.device = this.deviceFor(surface);
    return function () { self.activeSurface = keep.s; self.mockup = keep.m; self.mockupImg = keep.mi; self.device = keep.d; };
  };

  // Yüzey sekmesi değişimi: mockup/cihaz/kalite/kontroller birlikte güncellenir
  P.setActiveSurface = function (s) {
    this.activeSurface = s;
    this.mockup = this.findMockup(this.variant ? this.variant.option1 : '', s);
    this.device = this.deviceFor(s);
    this.loadMockupImage();
    this.renderSurfaceTabs();
    this.updateControls();
    this.updateQuality();
    this.updateCTA();
    this.draw();
  };

  P.findMockup = function (model, surface) {
    var m = norm(model), s = surface || 'back';
    var best = null;
    for (var i = 0; i < this.mockups.length; i++) {
      var b = this.mockups[i];
      if (!b.image) continue;
      var bm = norm(b.model), bs = b.surface || 'back';
      if (bs !== s) continue;
      if (bm === m) return b;
      if (!best && bm === '' ) best = b; // kategori geneli (model boş)
    }
    return best;
  };

  P.loadMockupImage = function () {
    var self = this;
    this.mockupImg = null;
    if (!this.mockup || !this.mockup.image) { this.draw(); return; }
    var src = this.mockup.image;
    if (this.mockupCache[src]) { this.mockupImg = this.mockupCache[src]; this.draw(); return; }
    loadImage(src).then(function (img) { self.mockupCache[src] = img; if (self.mockup && self.mockup.image === src) { self.mockupImg = img; self.resize(); } })
      .catch(function () { console.warn('[stickidy] mockup yüklenemedi', src); self.draw(); });
  };

  /* ------------------------------ yüzey sekmeleri -------------------------- */
  P.renderSurfaceTabs = function () {
    var box = $(this.root, '[data-stk-surfaces]');
    if (!box) return;
    var self = this;
    var copyBtn = $(this.root, '[data-stk-copy-surface]');
    if (this.surfaces.length < 2) { box.hidden = true; box.innerHTML = ''; if (copyBtn) copyBtn.hidden = true; return; }
    box.hidden = false;
    box.innerHTML = '';
    this.surfaces.forEach(function (s) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'stk-cz__tab' + (s === self.activeSurface ? ' is-active' : '');
      b.textContent = SURFACE_LABELS[s] || s;
      var has = self.layers[s] && self.layers[s].img;
      b.innerHTML = '<span>' + b.textContent + '</span>' + (has ? '<i class="stk-cz__tab-dot" aria-hidden="true"></i>' : '');
      on(b, 'click', function () { if (self.busy) return; self.setActiveSurface(s); });
      box.appendChild(b);
    });
    if (copyBtn) {
      var other = this.surfaces.filter(function (s) { return s !== self.activeSurface; })[0];
      copyBtn.hidden = !(other && this.layers[other] && this.layers[other].img && !(this.layers[this.activeSurface] && this.layers[this.activeSurface].img));
      copyBtn.textContent = (SURFACE_LABELS[other] || '') + ' görselini buraya kopyala';
    }
  };

  /* --------------------------------- geometri ----------------------------- */
  P.resize = function () {
    var ratio = this.category === 'macbook' ? 1.35 : (this.category === 'ipad' ? 0.9 : (this.category === 'artframe' ? 0.8 : 0.78));
    if (this.mockupImg) ratio = this.mockupImg.width / this.mockupImg.height;
    var w = this.wrap.clientWidth || 600;
    var maxH = Math.max(320, Math.min(window.innerHeight * 0.72, 760));
    var h = clamp(w / ratio, 320, maxH);
    this.wrap.style.height = h + 'px';
    var dpr = Math.min(window.devicePixelRatio || 1, 2.5);
    this.canvas.width = Math.round(w * dpr);
    this.canvas.height = Math.round(h * dpr);
    // CSS boyutu %100 (stil dosyası); piksel genişlik yazılmaz ki kolon daralabilsin
    this.dpr = dpr;
    this.draw();
  };

  // Ekran geometrisi: mm -> px dönüşümü. Orijin = cihazın sol-üst köşesi.
  P.geometry = function (W, H, pad) {
    var d = this.device, b = this.bleed;
    var bx, by, bw, bh; // mm cinsinden çizim sınırları (cihaz sol-üst'e göre)
    if (this.mockupImg && this.mockup) {
      var a = this.mockup.area; // [% x, % y, % w, % h]
      bw = 100 / a[2] * d.w; bh = 100 / a[3] * d.h;
      bx = -a[0] / a[2] * d.w; by = -a[1] / a[3] * d.h;
    } else if (this.category === 'artframe') {
      var fo = FRAME.face - FRAME.lip; // çerçevenin baskı dışına taşan kısmı
      if (this.view === 'wall') {
        var floorY = d.h / 2 + 1500, topM = -fo - 150, needH = (floorY + 220) - topM; // çerçeve üstü + zemin şeridi sığmalı
        bw = Math.max(1650, needH * W / H); bh = bw * H / W; bx = -(bw - d.w) / 2; by = topM;
      }
      else if (this.view === 'angle') { bx = -fo - 40; by = -fo - 30; bw = d.w + 2 * fo + 80; bh = d.h + 2 * fo + 60; }
      else { bx = -fo - 14; by = -fo - 14; bw = d.w + 2 * fo + 28; bh = d.h + 2 * fo + 28; }
    } else {
      bx = -b - 3; by = -b - 3; bw = d.w + 2 * b + 6; bh = d.h + 2 * b + 6;
    }
    var ppm = this.category === 'artframe' && this.view === 'wall' ? W / bw : Math.min((W - 2 * pad) / bw, (H - 2 * pad) / bh);
    return { ppm: ppm, ox: (W - bw * ppm) / 2 - bx * ppm, oy: (H - bh * ppm) / 2 - by * ppm, bx: bx, by: by, bw: bw, bh: bh };
  };

  P.activeLayer = function () { return this.layers[this.activeSurface] || null; };

  // Döndürülmüş görselin taşma payı dahil tüm cihazı örtmesi için gereken mm/px ölçeği
  P.coverScale = function (L) { return this.coverScaleFor(L, this.device); };
  P.coverScaleFor = function (L, d) {
    var b = this.bleed;
    var W = d.w + 2 * b, H = d.h + 2 * b;
    var th = (L.rot || 0) * Math.PI / 180, c = Math.abs(Math.cos(th)), s = Math.abs(Math.sin(th));
    return Math.max((W * c + H * s) / L.w, (W * s + H * c) / L.h);
  };
  P.containScale = function (L) {
    var d = this.device;
    return Math.min(d.w / L.w, d.h / L.h);
  };

  /* ---------------------------------- çizim ------------------------------- */
  P.draw = function () {
    var ctx = this.ctx, dpr = this.dpr || 1;
    var W = this.canvas.width / dpr, H = this.canvas.height / dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, W, H);
    var g = this.geometry(W, H, 18);
    this.geo = g;
    this.drawScene(ctx, g, { interactive: true });
  };

  P.drawScene = function (ctx, g, opts) {
    var d = this.device, b = this.bleed, L = this.activeLayer();
    ctx.save();
    ctx.translate(g.ox, g.oy);
    ctx.scale(g.ppm, g.ppm);
    var lw = 1 / g.ppm; // 1 px

    if (this.mockupImg && this.mockup) {
      // ---- merchant mockup: görsel altta, PNG mockup üstte ----
      if (L && L.img) {
        ctx.save(); roundRect(ctx, 0, 0, d.w, d.h, d.r); ctx.clip();
        ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, d.w, d.h);
        this.drawLayer(ctx, L, opts.interactive === false); ctx.restore();
      } else {
        ctx.fillStyle = '#efefef'; roundRect(ctx, 0, 0, d.w, d.h, d.r); ctx.fill();
      }
      ctx.drawImage(this.mockupImg, g.bx, g.by, g.bw, g.bh);
      ctx.restore();
      return;
    }

    if (this.category === 'artframe') { if (this.view === 'angle') this.drawAngleScene(ctx, g, opts, L); else this.drawFrameScene(ctx, g, opts, L); ctx.restore(); return; }

    // ---- vektör mockup ----
    // gövde
    ctx.save();
    ctx.shadowColor = 'rgba(0,0,0,0.18)'; ctx.shadowBlur = 8 / g.ppm * 2; ctx.shadowOffsetY = 1.2;
    ctx.fillStyle = '#ececec'; roundRect(ctx, 0, 0, d.w, d.h, d.r); ctx.fill();
    ctx.restore();

    var skin = d.geo && typeof Path2D === 'function' ? this.skinPath(d) : null;
    if (L && L.img) {
      // taşma payı: soluk
      if (opts.interactive !== false) {
        ctx.save(); roundRect(ctx, -b, -b, d.w + 2 * b, d.h + 2 * b, d.r + b); ctx.clip();
        ctx.globalAlpha = 0.28; this.drawLayer(ctx, L, false); ctx.restore();
      }
      // kaplama alanı: görsel yalnızca kesikler dışında (kamera adası, logo vb. cihaz olarak görünür)
      ctx.save();
      if (skin) ctx.clip(skin, 'evenodd'); else { roundRect(ctx, 0, 0, d.w, d.h, d.r); ctx.clip(); }
      ctx.fillStyle = '#ffffff'; ctx.fillRect(-b, -b, d.w + 2 * b, d.h + 2 * b);
      this.drawLayer(ctx, L, opts.interactive === false); ctx.restore();
    }
    // kesik kenarları (kaplamanın bittiği yer)
    if (skin) { ctx.save(); ctx.lineWidth = lw * 1.2; ctx.strokeStyle = 'rgba(0,0,0,0.30)'; ctx.stroke(skin); ctx.restore(); }

    // kenar çizgisi
    ctx.lineWidth = lw; ctx.strokeStyle = 'rgba(0,0,0,0.55)';
    roundRect(ctx, 0, 0, d.w, d.h, d.r); ctx.stroke();

    this.drawOverlay(ctx, d, g.ppm);

    // kesim/taşma çizgisi
    if (opts.interactive !== false && b > 0) {
      ctx.save(); ctx.setLineDash([3, 2]); ctx.lineWidth = lw; ctx.strokeStyle = 'rgba(0,0,0,0.35)';
      roundRect(ctx, -b, -b, d.w + 2 * b, d.h + 2 * b, d.r + b); ctx.stroke(); ctx.restore();
    }
    ctx.restore();
  };

  // Katmanı mm uzayında çizer (orijin cihaz sol-üst).
  P.drawLayer = function (ctx, L, forceFull) {
    var d = this.device;
    var img = (forceFull || !L.display) ? L.img : L.display;
    var w = L.w * L.scale, h = L.h * L.scale; // mm — display kopyası küçük olsa da hedef boyut aynı
    ctx.save();
    ctx.translate(d.w / 2 + L.x, d.h / 2 + L.y);
    ctx.rotate(L.rot * Math.PI / 180);
    ctx.scale(L.fx ? -1 : 1, L.fy ? -1 : 1);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, -w / 2, -h / 2, w, h);
    ctx.restore();
  };

  // Kaplama kesikleri (mm): kamera adası + pay, yüzen lensler/flaş, Apple logosu, Flip kapak ekranı, MacBook ayakları.
  // Dönen Path2D: gövde dikdörtgeni + kesikler; 'evenodd' ile kırpılınca yalnızca kaplama alanı kalır.
  // Kaplama: gövde + kamera adası yüzeyi de kaplı; adanın kenarında ince boşluk halkası (GAP), lens/flaş/LiDAR/mik delikleri,
  // Apple logosu birebir kesik, Flip kapak ekranı açık, MacBook alt ayakları delik. 'evenodd' ile kırpılır.
  var ISLAND_GAP = 1.2;   // ada kenarındaki boş halkanın toplam genişliği (mm)
  P.skinPath = function (d) {
    var g = d.geo, path = new Path2D();
    var rr = function (x, y, w, h, r) { r = Math.max(0.2, Math.min(r, w / 2, h / 2)); path.moveTo(x + r, y); path.arcTo(x + w, y, x + w, y + h, r); path.arcTo(x + w, y + h, x, y + h, r); path.arcTo(x, y + h, x, y, r); path.arcTo(x, y, x + w, y, r); path.closePath(); };
    var circ = function (cx, cy, r) { path.moveTo(cx + r, cy); path.arc(cx, cy, r, 0, Math.PI * 2); path.closePath(); };
    rr(0, 0, d.w, d.h, d.r);
    if (!g) return path;
    if (this.category === 'macbook' && this.activeSurface === 'bottom') {
      [[18, 18], [g.w - 18, 18], [18, g.h - 18], [g.w - 18, g.h - 18]].forEach(function (p) { circ(p[0], p[1], 4.5); });
      return path;
    }
    if (g.screen) rr(g.screen[0], g.screen[1], g.screen[2], g.screen[3], g.screen[4]);
    if (g.island) { var h = ISLAND_GAP / 2, b = g.island; rr(b[0] - h, b[1] - h, b[2] + 2 * h, b[3] + 2 * h, b[4] + h); rr(b[0] + h, b[1] + h, b[2] - 2 * h, b[3] - 2 * h, Math.max(0.2, b[4] - h)); }
    var inScreen = function (cx, cy) { var b = g.screen; return b && cx >= b[0] && cx <= b[0] + b[2] && cy >= b[1] && cy <= b[1] + b[3]; };
    (g.lenses || []).forEach(function (l) { if (!inScreen(l[0], l[1])) circ(l[0], l[1], l[2]); });
    (g.dots || []).forEach(function (dt) { if (!inScreen(dt[0], dt[1])) circ(dt[0], dt[1], dt[2]); });
    if (g.logo && APPLE_PATH_READY()) {
      var sc = g.logo[3] / 24, mtx = new DOMMatrix().translate(g.logo[0] - 12.2 * sc, g.logo[1] - 12 * sc).scale(sc, sc);
      path.addPath(APPLE_PATH, mtx);
    }
    return path;
  };
  function APPLE_PATH_READY() { if (!APPLE_PATH && typeof Path2D === 'function') { try { APPLE_PATH = new Path2D(APPLE_SVG); } catch (e) { APPLE_PATH = null; } } return !!APPLE_PATH && typeof DOMMatrix === 'function'; }

  // dimensions.com geometrisiyle arka yüz: ada, lensler, flaş/LiDAR/mikrofon, logo, cam paneller
  P.drawGeo = function (ctx, g) {
    var self = this;
    var rr = function (b, fill, stroke, lw) { roundRect(ctx, b[0], b[1], b[2], b[3], b[4]); if (fill) { ctx.fillStyle = fill; ctx.fill(); } if (stroke) { ctx.strokeStyle = stroke; ctx.lineWidth = lw || 0.35; ctx.stroke(); } };
    var circ = function (cx, cy, r, fill, stroke, lw) { ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2); if (fill) { ctx.fillStyle = fill; ctx.fill(); } if (stroke) { ctx.strokeStyle = stroke; ctx.lineWidth = lw || 0.3; ctx.stroke(); } };
    var L0 = this.activeLayer(), hasImg = !!(L0 && L0.img); // görsel varken ada/cam yüzeyine tint basma (kaplama oradadır)
    (g.glass || []).forEach(function (b) { rr(b, hasImg ? null : 'rgba(0,0,0,0.025)', 'rgba(0,0,0,0.12)', 0.3); });
    if (g.screen) { rr(g.screen, '#141416', 'rgba(0,0,0,0.35)', 0.4); ctx.save(); ctx.globalAlpha = 0.08; rr([g.screen[0] + 2, g.screen[1] + 2, g.screen[2] - 4, (g.screen[3] - 4) * 0.35, Math.max(1, g.screen[4] - 2)], '#fff'); ctx.restore(); }
    if (g.island) { ctx.save(); if (!hasImg) { ctx.shadowColor = 'rgba(0,0,0,0.12)'; ctx.shadowBlur = 1.2; ctx.shadowOffsetY = 0.4; } rr(g.island, hasImg ? null : 'rgba(0,0,0,0.06)', 'rgba(0,0,0,0.3)', 0.35); ctx.restore(); }
    if (g.inner) rr(g.inner, null, 'rgba(0,0,0,0.14)', 0.3);
    (g.lenses || []).forEach(function (l) {
      var cx = l[0], cy = l[1], r0 = l[2], r1 = l[3], r2 = l[4];
      circ(cx, cy, r0, '#d3d5da', 'rgba(0,0,0,0.32)', 0.3);
      circ(cx, cy, r1, '#0f1013');
      circ(cx, cy, Math.max(0.6, r2), '#26304a');
      circ(cx, cy, Math.max(0.4, r2 * 0.55), '#0b0d14');
      circ(cx - r2 * 0.38, cy - r2 * 0.38, Math.max(0.25, r2 * 0.22), 'rgba(255,255,255,0.45)');
    });
    (g.dots || []).forEach(function (d) {
      var cx = d[0], cy = d[1], r = d[2], t = d[3];
      if (t === 'flash') { circ(cx, cy, r, '#f2e6b5', 'rgba(0,0,0,0.22)', 0.25); circ(cx, cy, r * 0.55, '#e7d58d'); }
      else if (t === 'lidar') { circ(cx, cy, r, '#1b1b1e', 'rgba(0,0,0,0.3)', 0.25); circ(cx - r * 0.3, cy - r * 0.3, r * 0.25, 'rgba(255,255,255,0.25)'); }
      else circ(cx, cy, r, '#2d2d30');
    });
    if (this.category === 'macbook' && this.activeSurface === 'bottom') {
      ctx.fillStyle = 'rgba(0,0,0,0.35)';
      [[18, 18], [g.w - 18, 18], [18, g.h - 18], [g.w - 18, g.h - 18]].forEach(function (p) { circ(p[0], p[1], 4.5, 'rgba(0,0,0,0.35)'); });
    } else if (g.logo) {
      drawAppleLogo(ctx, g.logo[0], g.logo[1], g.logo[3], '#b9b9bd', 'rgba(0,0,0,0.25)');
    }
  };

  /* ------------------------------- Art Frame ------------------------------ */
  // Oda arka planı (duvar görünümü): duvar + süpürgelik + zemin, sol altta konsol masası silueti (ölçek referansı)
  P.drawRoom = function (ctx, g) {
    var d = this.device, bx = g.bx, by = g.by, bw = g.bw, bh = g.bh, floorY = d.h / 2 + 1500, bottom = by + bh;
    // duvar: sıcak kırık beyaz, yukarıdan aydınlanma + köşe vinyeti
    var wall = ctx.createLinearGradient(0, by, 0, floorY); wall.addColorStop(0, '#f4f1ea'); wall.addColorStop(0.55, '#ece8df'); wall.addColorStop(1, '#e2ddd2');
    ctx.fillStyle = wall; ctx.fillRect(bx, by, bw, floorY - by);
    var vg = ctx.createRadialGradient(bx + bw * 0.5, floorY - 1500, 200, bx + bw * 0.5, floorY - 1200, bw * 0.75); vg.addColorStop(0, 'rgba(255,255,255,0.10)'); vg.addColorStop(1, 'rgba(0,0,0,0.10)');
    ctx.fillStyle = vg; ctx.fillRect(bx, by, bw, floorY - by);
    // süpürgelik
    ctx.fillStyle = '#f7f6f2'; ctx.fillRect(bx, floorY - 110, bw, 110); ctx.fillStyle = 'rgba(0,0,0,0.10)'; ctx.fillRect(bx, floorY - 110, bw, 8); ctx.fillStyle = 'rgba(0,0,0,0.16)'; ctx.fillRect(bx, floorY - 4, bw, 4);
    // zemin: meşe parke, perspektif çizgileri + duvar dibi gölgesi
    var fl = ctx.createLinearGradient(0, floorY, 0, bottom); fl.addColorStop(0, '#b99a72'); fl.addColorStop(1, '#a8885f');
    ctx.fillStyle = fl; ctx.fillRect(bx, floorY, bw, bottom - floorY);
    ctx.strokeStyle = 'rgba(60,35,10,0.18)'; ctx.lineWidth = 3;
    for (var i = 0; i <= 14; i++) { var x0 = bx + bw * i / 14, x1 = bx + bw / 2 + (x0 - bx - bw / 2) * 1.35; ctx.beginPath(); ctx.moveTo(x0, floorY); ctx.lineTo(x1, bottom); ctx.stroke(); }
    for (var yy = floorY + 90; yy < bottom; yy += 130) { ctx.beginPath(); ctx.moveTo(bx, yy); ctx.lineTo(bx + bw, yy); ctx.stroke(); }
    var fs2 = ctx.createLinearGradient(0, floorY, 0, floorY + 120); fs2.addColorStop(0, 'rgba(0,0,0,0.22)'); fs2.addColorStop(1, 'rgba(0,0,0,0)'); ctx.fillStyle = fs2; ctx.fillRect(bx, floorY, bw, 120);
    // konsol masası (yükseklik 80 cm) çerçevenin altında, meşe + siyah metal ayak
    var tw = 1200, tx = d.w / 2 - tw / 2, ty = floorY - 800;
    ctx.save(); ctx.shadowColor = 'rgba(0,0,0,0.25)'; ctx.shadowBlur = 30; ctx.shadowOffsetY = 12;
    var tg = ctx.createLinearGradient(0, ty, 0, ty + 40); tg.addColorStop(0, '#c9a878'); tg.addColorStop(1, '#a98a5e'); ctx.fillStyle = tg; ctx.fillRect(tx, ty, tw, 40); ctx.restore();
    ctx.fillStyle = '#2a2a2c'; ctx.fillRect(tx + 40, ty + 40, 22, 760); ctx.fillRect(tx + tw - 62, ty + 40, 22, 760); ctx.fillRect(tx + 40, ty + 420, tw - 80, 14);
    // masada: kitap yığını (sağ), seramik vazo + okaliptüs (sol), küçük mumluk
    ctx.fillStyle = '#e9e4da'; ctx.fillRect(tx + tw - 380, ty - 30, 260, 30); ctx.fillStyle = '#3d4a5c'; ctx.fillRect(tx + tw - 360, ty - 58, 220, 28); ctx.fillStyle = '#b8574a'; ctx.fillRect(tx + tw - 340, ty - 82, 190, 24);
    ctx.fillStyle = '#d8d3c8'; roundRect(ctx, tx + 120, ty - 260, 130, 260, 24); ctx.fill(); ctx.fillStyle = 'rgba(0,0,0,0.12)'; roundRect(ctx, tx + 120, ty - 260, 40, 260, 20); ctx.fill();
    ctx.strokeStyle = '#6f7f5a'; ctx.lineWidth = 8; ctx.lineCap = 'round';
    [[-40, -560, -20], [30, -620, 10], [90, -540, 40], [-110, -500, -60]].forEach(function (p) { ctx.beginPath(); ctx.moveTo(tx + 185, ty - 250); ctx.quadraticCurveTo(tx + 185 + p[2], ty - 400, tx + 185 + p[0], ty + p[1]); ctx.stroke(); });
    ctx.fillStyle = '#8fa07a'; [[-40, -560], [30, -620], [90, -540], [-110, -500], [0, -430], [60, -470], [-60, -400]].forEach(function (p) { ctx.beginPath(); ctx.ellipse(tx + 185 + p[0], ty + p[1], 34, 18, p[0] * 0.01, 0, Math.PI * 2); ctx.fill(); });
    ctx.fillStyle = '#c8c2b6'; roundRect(ctx, tx + 330, ty - 70, 60, 70, 8); ctx.fill(); ctx.fillStyle = '#f2e9d2'; ctx.fillRect(tx + 344, ty - 100, 32, 30);
    // çerçevenin duvara düşen gölgesi (çerçeve çizilmeden önce)
    ctx.save(); ctx.shadowColor = 'rgba(0,0,0,0.30)'; ctx.shadowBlur = 40; ctx.shadowOffsetY = 18; ctx.shadowOffsetX = 6; ctx.fillStyle = 'rgba(0,0,0,0.001)'; ctx.fillRect(-13, -13, d.w + 26, d.h + 26); ctx.restore();
    // ölçek etiketi
    ctx.fillStyle = 'rgba(0,0,0,0.42)'; ctx.font = '500 28px Jost, sans-serif'; ctx.textAlign = 'left'; ctx.fillText('Gerçek ölçek · 50 × 70 cm · göz hizası', bx + 70, by + 80);
  };
  // Çerçeve + baskı + yüzey efekti. Orijin = baskı alanının sol üstü (mm).
  P.drawFrameScene = function (ctx, g, opts, L) {
    var d = this.device, b = this.bleed, fc = this.frameColor || FRAME_COLORS[0], lw = 1 / g.ppm;
    var face = FRAME.face, lip = FRAME.lip, fo = face - lip;
    var surface = (this.variant && this.variant.option1) || 'Standart';
    var textured = /doku/i.test(surface), glossy = /vernik|parlak/i.test(surface);
    if (this.view === 'wall') this.drawRoom(ctx, g);
    // dış gölge
    if (this.view !== 'wall') { ctx.save(); ctx.shadowColor = 'rgba(0,0,0,0.30)'; ctx.shadowBlur = 26; ctx.shadowOffsetY = 12; ctx.shadowOffsetX = 4; ctx.fillStyle = fc.c; ctx.fillRect(-fo, -fo, d.w + 2 * fo, d.h + 2 * fo); ctx.restore(); }
    // baskı alanı: beyaz + görsel (taşma payı soluk, ön görünümde)
    ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, d.w, d.h);
    if (L && L.img) {
      if (opts.interactive !== false && this.view === 'front') { ctx.save(); ctx.beginPath(); ctx.rect(-b, -b, d.w + 2 * b, d.h + 2 * b); ctx.clip(); ctx.globalAlpha = 0.28; this.drawLayer(ctx, L, false); ctx.restore(); }
      ctx.save(); ctx.beginPath(); ctx.rect(lip, lip, d.w - 2 * lip, d.h - 2 * lip); ctx.clip();
      this.drawLayer(ctx, L, opts.interactive === false);
      // canvas kumaş dokusu: açık/koyu dönüşümlü ince çizgiler (parlaklık nötr)
      ctx.save(); ctx.lineWidth = 0.4;
      for (var y = lip; y < d.h; y += 2.4) { ctx.strokeStyle = (Math.round(y / 2.4) % 2) ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.05)'; ctx.beginPath(); ctx.moveTo(lip, y + 0.2); ctx.lineTo(d.w - lip, y + 0.2); ctx.stroke(); }
      ctx.restore();
      if (textured) { // kabartma: aynı görselin soft-light ile ±kaydırılmış gri kopyaları → ışık/gölge kenarları, ortalama parlaklık korunur
        ctx.save(); ctx.globalCompositeOperation = 'soft-light'; ctx.globalAlpha = 0.5;
        try { ctx.filter = 'grayscale(1) contrast(1.8) brightness(1.15)'; } catch (x) { /* yoksay */ }
        ctx.translate(-0.8, -0.8); this.drawLayer(ctx, L, opts.interactive === false); ctx.restore();
        ctx.save(); ctx.globalCompositeOperation = 'soft-light'; ctx.globalAlpha = 0.5;
        try { ctx.filter = 'grayscale(1) contrast(1.8) brightness(1.15) invert(1)'; } catch (x) { /* yoksay */ }
        ctx.translate(0.8, 0.8); this.drawLayer(ctx, L, opts.interactive === false); ctx.restore();
      }
      if (glossy) { // selektif parlak vernik: hafif parlaklık/kontrast artışı (screen) + açılı ışık süpürmesi
        ctx.save(); ctx.globalCompositeOperation = 'screen'; ctx.globalAlpha = 0.16; this.drawLayer(ctx, L, opts.interactive === false); ctx.restore();
        var sw = ctx.createLinearGradient(0, 0, d.w, d.h); sw.addColorStop(0.30, 'rgba(255,255,255,0)'); sw.addColorStop(0.42, 'rgba(255,255,255,0.20)'); sw.addColorStop(0.50, 'rgba(255,255,255,0.04)'); sw.addColorStop(0.58, 'rgba(255,255,255,0.16)'); sw.addColorStop(0.70, 'rgba(255,255,255,0)');
        ctx.save(); ctx.globalCompositeOperation = 'screen'; ctx.fillStyle = sw; ctx.fillRect(0, 0, d.w, d.h); ctx.restore();
      }
      ctx.restore();
    } else if (opts.interactive !== false) { ctx.fillStyle = '#f3f3f1'; ctx.fillRect(lip, lip, d.w - 2 * lip, d.h - 2 * lip); }
    // çerçeve: 4 kenar (gönye), her kenar: dış yuvarlak pah (parlak) · yüz (ışık gradyanı + damar) · iç pah (gölgeli)
    var pts = { x0: -fo, y0: -fo, x1: d.w + fo, y1: d.h + fo, ix0: lip, iy0: lip, ix1: d.w - lip, iy1: d.h - lip };
    var light = [1.0, 0.86, 0.72, 0.93]; // üst, sağ, alt, sol — ışık sol-üstten
    var sides = [
      { p: [[pts.x0, pts.y0], [pts.x1, pts.y0], [pts.ix1, pts.iy0], [pts.ix0, pts.iy0]], h: true, dir: 1 },
      { p: [[pts.x1, pts.y0], [pts.x1, pts.y1], [pts.ix1, pts.iy1], [pts.ix1, pts.iy0]], h: false, dir: -1 },
      { p: [[pts.x1, pts.y1], [pts.x0, pts.y1], [pts.ix0, pts.iy1], [pts.ix1, pts.iy1]], h: true, dir: -1 },
      { p: [[pts.x0, pts.y1], [pts.x0, pts.y0], [pts.ix0, pts.iy0], [pts.ix0, pts.iy1]], h: false, dir: 1 }
    ];
    var dark = (function (hex) { var n = parseInt(hex.slice(1), 16); return (0.2126 * ((n >> 16) & 255) + 0.7152 * ((n >> 8) & 255) + 0.0722 * (n & 255)) / 255 < 0.45; })(fc.c);
    sides.forEach(function (sd, si) {
      var k = light[si];
      ctx.save();
      ctx.beginPath(); ctx.moveTo(sd.p[0][0], sd.p[0][1]); ctx.lineTo(sd.p[1][0], sd.p[1][1]); ctx.lineTo(sd.p[2][0], sd.p[2][1]); ctx.lineTo(sd.p[3][0], sd.p[3][1]); ctx.closePath(); ctx.clip();
      var gx0 = sd.h ? 0 : (sd.dir > 0 ? pts.x0 : pts.x1), gy0 = sd.h ? (sd.dir > 0 ? pts.y0 : pts.y1) : 0;
      var gx1 = sd.h ? 0 : gx0 + sd.dir * face, gy1 = sd.h ? gy0 + sd.dir * face : 0;
      var fg = ctx.createLinearGradient(gx0, gy0, gx1, gy1);
      fg.addColorStop(0, 'rgba(255,255,255,0.45)'); fg.addColorStop(0.12, 'rgba(255,255,255,0.10)'); fg.addColorStop(0.55, 'rgba(0,0,0,0)'); fg.addColorStop(0.82, 'rgba(0,0,0,0.06)'); fg.addColorStop(0.86, 'rgba(0,0,0,0.30)'); fg.addColorStop(1, 'rgba(0,0,0,0.42)');
      ctx.fillStyle = fc.c; ctx.fillRect(pts.x0, pts.y0, pts.x1 - pts.x0, pts.y1 - pts.y0);
      ctx.fillStyle = fg; ctx.fillRect(pts.x0, pts.y0, pts.x1 - pts.x0, pts.y1 - pts.y0);
      ctx.fillStyle = 'rgba(0,0,0,' + ((1 - k) * 0.5).toFixed(2) + ')'; ctx.fillRect(pts.x0, pts.y0, pts.x1 - pts.x0, pts.y1 - pts.y0);
      ctx.strokeStyle = fc.grain; ctx.globalAlpha = fc.n === 'Doğal Ahşap' ? 0.5 : (dark ? 0.12 : 0.16); ctx.lineWidth = 0.35;
      var len = sd.h ? (pts.x1 - pts.x0) : (pts.y1 - pts.y0), start = sd.h ? pts.x0 : pts.y0;
      for (var gi = 0; gi < 9; gi++) {
        var off = 1.2 + gi * 1.7 + (gi % 3) * 0.4, wob = 0.25 + (gi % 4) * 0.12, ph = gi * 1.3 + si;
        ctx.beginPath();
        for (var t = 0; t <= len; t += 6) {
          var pos = start + t, o = off + Math.sin(t / 60 + ph) * wob;
          var px2 = sd.h ? pos : (sd.dir > 0 ? pts.x0 + o : pts.x1 - o), py2 = sd.h ? (sd.dir > 0 ? pts.y0 + o : pts.y1 - o) : pos;
          if (t === 0) ctx.moveTo(px2, py2); else ctx.lineTo(px2, py2);
        }
        ctx.stroke();
      }
      ctx.globalAlpha = 1;
      ctx.restore();
    });
    ctx.strokeStyle = 'rgba(0,0,0,0.28)'; ctx.lineWidth = lw * 1.1; ctx.beginPath();
    ctx.moveTo(pts.x0, pts.y0); ctx.lineTo(pts.ix0, pts.iy0); ctx.moveTo(pts.x1, pts.y0); ctx.lineTo(pts.ix1, pts.iy0); ctx.moveTo(pts.x1, pts.y1); ctx.lineTo(pts.ix1, pts.iy1); ctx.moveTo(pts.x0, pts.y1); ctx.lineTo(pts.ix0, pts.iy1); ctx.stroke();
    ctx.strokeStyle = 'rgba(255,255,255,0.18)'; ctx.beginPath(); ctx.moveTo(pts.x0 + lw, pts.y0 + lw); ctx.lineTo(pts.ix0 + lw, pts.iy0 + lw); ctx.moveTo(pts.x1 - lw, pts.y1 - lw); ctx.lineTo(pts.ix1 - lw, pts.iy1 - lw); ctx.stroke();
    ctx.strokeStyle = 'rgba(0,0,0,0.45)'; ctx.lineWidth = lw * 1.2; ctx.strokeRect(pts.ix0, pts.iy0, pts.ix1 - pts.ix0, pts.iy1 - pts.iy0);
    ctx.strokeStyle = 'rgba(255,255,255,0.5)'; ctx.lineWidth = lw; ctx.strokeRect(pts.x0 + lw, pts.y0 + lw, pts.x1 - pts.x0 - 2 * lw, pts.y1 - pts.y0 - 2 * lw);
    ctx.strokeStyle = 'rgba(0,0,0,0.55)'; ctx.strokeRect(pts.x0, pts.y0, pts.x1 - pts.x0, pts.y1 - pts.y0);
    // baskı üstüne iç gölge (4 kenar; pah derinliği)
    [[lip, lip, d.w - 2 * lip, 9, 0, 1, 0.30], [lip, lip, 7, d.h - 2 * lip, 1, 0, 0.30], [lip, d.h - lip - 5, d.w - 2 * lip, 5, 0, -1, 0.12], [d.w - lip - 5, lip, 5, d.h - 2 * lip, -1, 0, 0.14]].forEach(function (r) {
      var x0 = r[4] < 0 ? r[0] + r[2] : r[0], y0 = r[5] < 0 ? r[1] + r[3] : r[1];
      var gr = ctx.createLinearGradient(x0, y0, x0 + r[4] * r[2], y0 + r[5] * r[3]); gr.addColorStop(0, 'rgba(0,0,0,' + r[6] + ')'); gr.addColorStop(1, 'rgba(0,0,0,0)'); ctx.fillStyle = gr; ctx.fillRect(r[0], r[1], r[2], r[3]);
    });
    // kesim/taşma çizgisi (ön, etkileşimli)
    if (opts.interactive !== false && this.view === 'front' && b > 0) { ctx.save(); ctx.setLineDash([3, 2]); ctx.lineWidth = lw; ctx.strokeStyle = 'rgba(0,0,0,0.35)'; ctx.strokeRect(-b, -b, d.w + 2 * b, d.h + 2 * b); ctx.restore(); }
    void self;
  };
  // 3/4 açı: ön sahne offscreen'e çizilir, sütun sütun perspektifle (sol kenar yakın) yeniden çizilir; sol yan yüz (27 mm derinlik) ve duvar gölgesi eklenir.
  P.drawAngleScene = function (ctx, g, opts, L) {
    var d = this.device, fc = this.frameColor || FRAME_COLORS[0], fo = FRAME.face - FRAME.lip, Wm = d.w + 2 * fo, Hm = d.h + 2 * fo;
    var sc = Math.min(3, Math.max(1.5, g.ppm * 1.5)), off = document.createElement('canvas');
    off.width = Math.round(Wm * sc); off.height = Math.round(Hm * sc);
    var oc = off.getContext('2d'); oc.translate(fo * sc, fo * sc); oc.scale(sc, sc);
    var keepView = this.view; this.view = 'front'; this.drawFrameScene(oc, { ppm: sc, ox: 0, oy: 0 }, { interactive: false }, L); this.view = keepView;
    // Pinhole: çerçeve dikey eksen etrafında θ döndürülmüş; sol kenar yakın. Kamera mesafesi F (mm); ölçek s = F / (F + z).
    var th = 38 * Math.PI / 180, cosT = Math.cos(th), sinT = Math.sin(th), F = Wm * 1.35;
    var cy = d.h / 2;
    var proj = function (xm) { var z = xm * sinT, sN = F / (F + z); return { x: xm * cosT * sN, s: sN }; }; // xm: sol kenardan uzaklık (mm)
    var pFar = proj(Wm), depthW = FRAME.depth * sinT * 1.0, totalW = pFar.x + depthW;
    var x0 = -fo + (Wm - totalW) / 2 + depthW;
    // duvar gölgesi (perspektif, sağa/aşağı)
    ctx.save(); try { ctx.filter = 'blur(9px)'; } catch (x) { /* yoksay */ }
    ctx.fillStyle = 'rgba(0,0,0,0.32)'; ctx.beginPath();
    ctx.moveTo(x0 + 12, cy - Hm / 2 + 24); ctx.lineTo(x0 + pFar.x + 22, cy - Hm * pFar.s / 2 + 28); ctx.lineTo(x0 + pFar.x + 22, cy + Hm * pFar.s / 2 + 34); ctx.lineTo(x0 + 12, cy + Hm / 2 + 30); ctx.closePath(); ctx.fill(); ctx.restore();
    // ön yüz: kaynak sütunları hedef x aralıklarına perspektifle
    var cols = off.width;
    for (var i = 0; i < cols; i++) {
      var p0 = proj(i / sc), p1 = proj((i + 1) / sc), h = Hm * p0.s;
      ctx.drawImage(off, i, 0, 1, off.height, x0 + p0.x, cy - h / 2, (p1.x - p0.x) + 0.08, h);
    }
    // sol yan yüz (derinlik 27 mm): yakın kenardan sola
    var hN = Hm, yN = cy - hN / 2, taper = 4;
    var side = ctx.createLinearGradient(x0 - depthW, 0, x0, 0); side.addColorStop(0, 'rgba(0,0,0,0.50)'); side.addColorStop(1, 'rgba(0,0,0,0.22)');
    ctx.beginPath(); ctx.moveTo(x0, yN); ctx.lineTo(x0 - depthW, yN + taper); ctx.lineTo(x0 - depthW, yN + hN - taper); ctx.lineTo(x0, yN + hN); ctx.closePath();
    ctx.fillStyle = fc.c; ctx.fill(); ctx.fillStyle = side; ctx.fill();
    ctx.save(); ctx.clip(); ctx.strokeStyle = fc.grain; ctx.globalAlpha = fc.n === 'Doğal Ahşap' ? 0.45 : 0.15; ctx.lineWidth = 0.35;
    for (var k = 1; k < 6; k++) { var xx = x0 - depthW * k / 6; ctx.beginPath(); ctx.moveTo(xx, yN); ctx.lineTo(xx, yN + hN); ctx.stroke(); } ctx.restore();
    ctx.strokeStyle = 'rgba(0,0,0,0.5)'; ctx.lineWidth = 1 / g.ppm; ctx.stroke();
    // üst kenar: ince açık şerit (yakın → uzak)
    ctx.beginPath(); ctx.moveTo(x0 - depthW, yN + taper); ctx.lineTo(x0, yN); ctx.lineTo(x0 + pFar.x, cy - Hm * pFar.s / 2); ctx.lineTo(x0 + pFar.x - depthW * 0.3 * pFar.s, cy - Hm * pFar.s / 2 + 1.2); ctx.closePath();
    ctx.fillStyle = 'rgba(255,255,255,0.22)'; ctx.fill();
  };
  P.setFrameColor = function (col) {
    this.frameColor = col;
    $$(this.root, '[data-stk-frame]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-stk-frame') === col.n); b.setAttribute('aria-pressed', b.getAttribute('data-stk-frame') === col.n ? 'true' : 'false'); });
    var nm = $(this.root, '[data-stk-frame-name]'); if (nm) nm.textContent = col.n;
    if (this.device && this.geo) this.draw();
  };
  P.setView = function (v) {
    this.view = v;
    $$(this.root, '[data-stk-view]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-stk-view') === v); });
    this.wrap.classList.toggle('is-angle', v === 'angle');
    this.wrap.classList.toggle('is-static', v !== 'front');
    if (this.device) this.resize();
  };

  // Kamera / logo katmanı — mm uzayında.
  P.drawOverlay = function (ctx, d, ppm) {
    if (d.geo) { this.drawGeo(ctx, d.geo); return; }
    var cam = d.cam;
    var lens = function (x, y, r) {
      ctx.fillStyle = '#d9d9d9'; ctx.beginPath(); ctx.arc(x, y, r + 0.9, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#1c1c1c'; ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#3a3f4a'; ctx.beginPath(); ctx.arc(x, y, r * 0.62, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = 'rgba(255,255,255,0.35)'; ctx.beginPath(); ctx.arc(x - r * 0.3, y - r * 0.3, r * 0.18, 0, Math.PI * 2); ctx.fill();
    };
    var flash = function (x, y, r) { ctx.fillStyle = '#f2e6b4'; ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.fill(); };
    var island = function (x, y, w, h, r) {
      ctx.save(); ctx.strokeStyle = 'rgba(0,0,0,0.25)'; ctx.lineWidth = 0.35; ctx.fillStyle = 'rgba(0,0,0,0.05)';
      roundRect(ctx, x, y, w, h, r); ctx.fill(); ctx.stroke(); ctx.restore();
    };
    var logo = function (cx, cy, hgt) { drawAppleLogo(ctx, cx, cy, hgt, '#b9b9bd', 'rgba(0,0,0,0.25)'); };

    switch (cam) {
      case 'triple':
        island(5, 5, 36, 36, 9); lens(15, 15, 6.4); lens(15, 31, 6.4); lens(31, 23, 6.4); flash(30.5, 11, 2.2); break;
      case 'dual':
        island(5, 5, 30, 30, 8); lens(13, 13, 6); lens(27, 27, 6); flash(27.5, 12, 2); break;
      case 'dual-v':
        island(5, 5, 23, 41, 10); lens(16.5, 16, 6.2); lens(16.5, 30.5, 6.2); flash(24, 11, 1.8); break;
      case 'single':
        island(5, 5, 20, 20, 7); lens(15, 15, 6); break;
      case 'plateau':
        island(5, 5, d.w - 10, 34, 9); lens(15, 15, 6.4); lens(15, 30, 6.4); lens(30, 22.5, 6.4); flash(d.w - 15, 12, 2.4); break;
      case 'bar':
        island(5, 5, d.w - 10, 20, 8); lens(16, 15, 6.4); flash(d.w - 15, 15, 2.2); break;
      case 'sam-triple':
        lens(13, 13, 5.5); lens(13, 28, 5.5); lens(13, 43, 5.5); flash(23.5, 15, 1.7); break;
      case 'sam-ultra':
        lens(13, 13, 6.2); lens(13, 29, 6.2); lens(13, 45, 6.2); lens(26, 33, 4.2); flash(26, 19, 1.8); break;
      case 'ipad':
        lens(11, 11, 4.6); logo(d.w / 2, d.h / 2, 24); break;
      case 'ipad-pro':
        island(5, 5, 24, 24, 7); lens(12, 12, 4.4); lens(12, 22, 4.4); flash(22, 12, 1.8); logo(d.w / 2, d.h / 2, 24); break;
      case 'mac':
        if (this.activeSurface === 'bottom') {
          ctx.fillStyle = 'rgba(0,0,0,0.35)';
          [[14, 14], [d.w - 14, 14], [14, d.h - 14], [d.w - 14, d.h - 14]].forEach(function (p) { ctx.beginPath(); ctx.arc(p[0], p[1], 4, 0, Math.PI * 2); ctx.fill(); });
        } else {
          logo(d.w / 2, d.h / 2, Math.min(d.h * 0.17, 42));
        }
        break;
      default: break;
    }
    void ppm;
  };

  /* --------------------------------- görsel ------------------------------- */
  P.setImageFile = function (file) {
    var self = this;
    if (this.busy) return;
    if (!file || !/^image\//.test(file.type) && !/\.(heic|heif)$/i.test(file.name)) { this.notice(this.t('err_type', 'Lütfen JPG veya PNG bir görsel seçin.'), true); return; }
    if (file.size > MAX_FILE_BYTES) { this.notice(this.t('err_file_big', 'Dosya çok büyük (maks. 40 MB). Lütfen daha küçük bir fotoğraf seçin.'), true); return; }
    this.setBusy(true, this.t('loading', 'Yükleniyor…'));
    var url = URL.createObjectURL(file);
    loadImage(url).then(function (img) {
      var w = img.width, h = img.height, full = img;
      var long = Math.max(w, h);
      // Kaynak görseli baskı için gereken üst sınıra bir kez küçült (24 MP+ fotoğraflar mobilde belleği aşıyor)
      var needLong = Math.ceil(Math.max(self.device.w, self.device.h) * 1.2 * self.dpi / MM_PER_INCH);
      var cap = Math.max(Math.min(SOURCE_MAX_LONG, needLong), 3000);
      if (long > cap) {
        var k = cap / long;
        var fc = document.createElement('canvas'); fc.width = Math.round(w * k); fc.height = Math.round(h * k);
        var fx = fc.getContext('2d'); fx.imageSmoothingQuality = 'high'; fx.drawImage(img, 0, 0, fc.width, fc.height);
        full = fc; w = fc.width; h = fc.height;
      }
      var display = full;
      if (Math.max(w, h) > DISPLAY_MAX) {
        var k2 = DISPLAY_MAX / Math.max(w, h);
        var c = document.createElement('canvas'); c.width = Math.round(w * k2); c.height = Math.round(h * k2);
        var cx = c.getContext('2d'); cx.imageSmoothingQuality = 'high'; cx.drawImage(full, 0, 0, c.width, c.height);
        display = c;
      }
      // küçük önizleme (blob URL'ye bağımlı kalmasın)
      var tc = document.createElement('canvas'), tk = 112 / Math.max(w, h); tc.width = Math.max(1, Math.round(w * tk)); tc.height = Math.max(1, Math.round(h * tk));
      tc.getContext('2d').drawImage(display, 0, 0, tc.width, tc.height);
      var L = { img: full, display: display, thumb: tc.toDataURL('image/jpeg', 0.7), w: w, h: h, srcW: img.width, srcH: img.height, x: 0, y: 0, rot: 0, fx: false, fy: false, scale: 1, zoomRel: 1, name: file.name, size: file.size };
      L.scale = self.coverScale(L);
      self.layers[self.activeSurface] = L;
      self.afterImageChange();
      self.setBusy(false);
    }).catch(function () {
      self.setBusy(false);
      self.notice(self.t('err_load', 'Görsel açılamadı. HEIC ise lütfen JPG olarak kaydedip tekrar deneyin.'), true);
    }).then(function () { try { URL.revokeObjectURL(url); } catch (e) { /* yoksay */ } });
  };

  P.afterImageChange = function () {
    var L = this.activeLayer();
    var has = !!(L && L.img);
    this.root.classList.toggle('has-image', has);
    var info = $(this.root, '[data-stk-file-info]');
    if (info) {
      info.hidden = !has;
      if (has) {
        var th = $(info, '[data-stk-thumb]'); if (th && L.thumb) th.src = L.thumb;
        var nm = $(info, '[data-stk-file-name]'); if (nm) nm.textContent = L.name;
        var mt = $(info, '[data-stk-file-meta]'); if (mt) mt.textContent = (L.srcW || L.w) + ' × ' + (L.srcH || L.h) + ' px';
      }
    }
    this.renderSurfaceTabs();
    this.updateControls();
    this.updateQuality();
    this.updateCTA();
    this.draw();
  };

  P.removeImage = function () {
    delete this.layers[this.activeSurface];
    this.fileInput.value = '';
    this.afterImageChange();
  };

  /* --------------------------------- kontroller --------------------------- */
  P.bindUI = function () {
    var self = this;
    $$(this.root, '[data-stk-upload-trigger]').forEach(function (b) { on(b, 'click', function () { self.fileInput.click(); }); });
    on(this.fileInput, 'change', function () { var f = self.fileInput.files && self.fileInput.files[0]; self.fileInput.value = ''; if (f) self.setImageFile(f); });

    // sürükle-bırak
    on(this.wrap, 'dragover', function (e) { e.preventDefault(); self.wrap.classList.add('is-dragover'); });
    on(this.wrap, 'dragleave', function () { self.wrap.classList.remove('is-dragover'); });
    on(this.wrap, 'drop', function (e) { e.preventDefault(); self.wrap.classList.remove('is-dragover'); var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; if (f) self.setImageFile(f); });

    var rm = $(this.root, '[data-stk-remove]'); if (rm) on(rm, 'click', function () { self.removeImage(); });

    $$(this.root, '[data-stk-action]').forEach(function (b) {
      on(b, 'click', function () { self.action(b.getAttribute('data-stk-action')); });
    });

    this.zoomSlider = $(this.root, '[data-stk-zoom]');
    this.rotSlider = $(this.root, '[data-stk-rot]');
    if (this.zoomSlider) on(this.zoomSlider, 'input', function () {
      var L = self.activeLayer(); if (!L) return;
      L.zoomRel = Math.pow(10, parseFloat(self.zoomSlider.value)); L.scale = self.coverScale(L) * L.zoomRel;
      self.updateQuality(); self.updateControls(true); self.updateCoverage(); self.draw();
    });
    if (this.rotSlider) on(this.rotSlider, 'input', function () {
      var L = self.activeLayer(); if (!L) return;
      L.rot = parseFloat(self.rotSlider.value); L.scale = self.coverScale(L) * (L.zoomRel || 1);
      self.updateQuality(); self.updateControls(true); self.updateCoverage(); self.draw();
    });

    var copyBtn = $(this.root, '[data-stk-copy-surface]');
    if (copyBtn) on(copyBtn, 'click', function () {
      var other = self.surfaces.filter(function (s) { return s !== self.activeSurface; })[0];
      var src = self.layers[other]; if (!src) return;
      var L = {}; for (var k in src) L[k] = src[k];
      L.scale = self.coverScaleFor(L, self.deviceFor(self.activeSurface)) * (L.zoomRel || 1);
      self.layers[self.activeSurface] = L; self.afterImageChange();
    });

    var qty = $(this.root, '[data-stk-qty]');
    $$(this.root, '[data-stk-qty-step]').forEach(function (b) {
      on(b, 'click', function () { var v = parseInt(qty.value, 10) || 1; v += parseInt(b.getAttribute('data-stk-qty-step'), 10); qty.value = clamp(v, 1, 99); });
    });

    $$(this.root, '[data-stk-add]').forEach(function (b) { on(b, 'click', function () { self.addToCart(); }); });

    var toggle = $(this.root, '[data-stk-desc-toggle]');
    if (toggle) on(toggle, 'click', function () { var p = toggle.parentNode; p.classList.toggle('is-open'); toggle.setAttribute('aria-expanded', p.classList.contains('is-open')); });
  };

  P.action = function (name) {
    var L = this.activeLayer();
    if (name === 'upload') { this.fileInput.click(); return; }
    if (!L) return;
    switch (name) {
      case 'zoom-in': this.zoomBy(1.12); break;
      case 'zoom-out': this.zoomBy(1 / 1.12); break;
      case 'rot-left': L.rot = Math.round((L.rot - 90) / 90) * 90; L.scale = this.coverScale(L) * (L.zoomRel || 1); break;
      case 'rot-right': L.rot = Math.round((L.rot + 90) / 90) * 90; L.scale = this.coverScale(L) * (L.zoomRel || 1); break;
      case 'flip-h': L.fx = !L.fx; break;
      case 'flip-v': L.fy = !L.fy; break;
      case 'fill': L.x = 0; L.y = 0; L.zoomRel = 1; L.scale = this.coverScale(L); break;
      case 'fit': L.x = 0; L.y = 0; L.scale = this.containScale(L); L.zoomRel = L.scale / this.coverScale(L); break;
      case 'center': L.x = 0; L.y = 0; break;
      case 'reset': L.x = 0; L.y = 0; L.rot = 0; L.fx = false; L.fy = false; L.zoomRel = 1; L.scale = this.coverScale(L); break;
      case 'remove': this.removeImage(); return;
    }
    if (L.rot > 180) L.rot -= 360; if (L.rot < -180) L.rot += 360;
    this.updateControls(); this.updateQuality(); this.updateCoverage(); this.draw();
  };

  P.zoomBy = function (f, ax, ay) {
    var L = this.activeLayer(); if (!L) return;
    var zr = clamp((L.zoomRel || 1) * f, 0.2, 8);
    f = zr / (L.zoomRel || 1);
    if (ax !== undefined) { // imleç etrafında yakınlaştır (mm)
      L.x = ax + (L.x - ax) * f; L.y = ay + (L.y - ay) * f;
    }
    L.zoomRel = zr; L.scale = this.coverScale(L) * zr;
  };

  P.updateControls = function (fromSlider) {
    var L = this.activeLayer();
    var has = !!(L && L.img);
    $$(this.root, '[data-stk-needs-image]').forEach(function (el) { el.disabled = !has; el.classList.toggle('is-disabled', !has); });
    $$(this.root, '[data-stk-action="flip-h"]').forEach(function (el) { el.classList.toggle('is-on', !!(L && L.fx)); el.setAttribute('aria-pressed', !!(L && L.fx)); });
    $$(this.root, '[data-stk-action="flip-v"]').forEach(function (el) { el.classList.toggle('is-on', !!(L && L.fy)); el.setAttribute('aria-pressed', !!(L && L.fy)); });
    if (!fromSlider) {
      if (this.zoomSlider) this.zoomSlider.value = has ? Math.log10(L.zoomRel || 1) : 0;
      if (this.rotSlider) this.rotSlider.value = has ? L.rot : 0;
    }
    var zv = $(this.root, '[data-stk-zoom-value]'); if (zv) zv.textContent = has ? Math.round((L.zoomRel || 1) * 100) + '%' : '—';
    var rv = $(this.root, '[data-stk-rot-value]'); if (rv) rv.textContent = has ? Math.round(L.rot) + '°' : '—';
    var empty = $(this.root, '[data-stk-empty]'); if (empty) empty.hidden = has;
    var hint = $(this.root, '[data-stk-hint]'); if (hint) hint.hidden = !has;
    var tb = $(this.root, '[data-stk-toolbar]'); if (tb) tb.classList.toggle('is-visible', has);
    this.canvas.style.touchAction = 'pan-y'; // dokunmatikte sayfa kaydırma serbest; taşıma için basılı tut (bindCanvas)
    this.updateCoverage();
  };

  // Görsel cihaz + taşma payını tamamen örtüyor mu? (dönüş dahil; köşeleri görsel uzayına çevirip kontrol)
  P.covers = function (L, d) {
    if (!L || !L.img) return true;
    d = d || this.device; var b = this.bleed;
    var W = d.w + 2 * b, H = d.h + 2 * b, cx = d.w / 2 + L.x, cy = d.h / 2 + L.y;
    var th = -(L.rot || 0) * Math.PI / 180, c = Math.cos(th), s = Math.sin(th);
    var hw = L.w * L.scale / 2, hh = L.h * L.scale / 2, eps = 0.05;
    var pts = [[-b, -b], [W - b, -b], [-b, H - b], [W - b, H - b]];
    for (var i = 0; i < pts.length; i++) {
      var dx = pts[i][0] - cx, dy = pts[i][1] - cy;
      var lx = dx * c - dy * s, ly = dx * s + dy * c; // görsel yerel uzayı (flip önemsiz, simetrik)
      if (Math.abs(lx) > hw + eps || Math.abs(ly) > hh + eps) return false;
    }
    return true;
  };
  P.updateCoverage = function () {
    var el = $(this.root, '[data-stk-coverage]'); if (!el) return;
    var L = this.activeLayer();
    var show = !!(L && L.img) && !this.covers(L);
    el.hidden = !show;
    if (show) el.textContent = this.t('coverage', 'Görsel kaplamanın tamamını örtmüyor: boş kalan kenarlar beyaz basılır. "Doldur" ile tamamını kaplayabilirsin.');
  };

  P.updateQuality = function () {
    var el = $(this.root, '[data-stk-quality]'); if (!el) return;
    var L = this.activeLayer();
    if (!L || !L.img) { el.hidden = true; return; }
    var dpi = MM_PER_INCH / L.scale; // baskıda inç başına görsel pikseli
    var level, text;
    if (dpi >= 220) { level = 'good'; text = this.t('q_good', 'Baskı kalitesi mükemmel'); }
    else if (dpi >= 140) { level = 'ok'; text = this.t('q_ok', 'Baskı kalitesi iyi'); }
    else if (dpi >= 90) { level = 'warn'; text = this.t('q_warn', 'Orta kalite — biraz küçültmeyi deneyin'); }
    else { level = 'bad'; text = this.t('q_bad', 'Düşük çözünürlük — baskı bulanık olabilir'); }
    el.hidden = false;
    el.className = 'stk-cz__quality is-' + level;
    el.innerHTML = '<i aria-hidden="true"></i><span>' + text + '</span><small>' + Math.round(dpi) + ' dpi</small>';
  };

  P.updateCTA = function () {
    var self = this;
    var soldOut = !!(this.variant && this.variant.available === false);
    var ready = !soldOut && this.surfaces.every(function (s) { return self.layers[s] && self.layers[s].img; });
    $$(this.root, '[data-stk-add]').forEach(function (b) { b.disabled = !ready || self.busy; });
    var miss = $(this.root, '[data-stk-missing]');
    if (miss) {
      var missing = this.surfaces.filter(function (s) { return !(self.layers[s] && self.layers[s].img); });
      miss.hidden = !missing.length && !soldOut;
      if (soldOut) miss.textContent = this.t('sold_out', 'Bu model şu an tükendi. Lütfen başka bir model seçin.');
      else if (missing.length) miss.textContent = this.surfaces.length > 1
        ? (missing.map(function (s) { return SURFACE_LABELS[s]; }).join(' ve ') + ' için fotoğraf ekleyin')
        : this.t('missing', 'Sepete eklemek için önce bir fotoğraf yükleyin');
    }
  };

  P.notice = function (msg, isError) {
    var el = $(this.root, '[data-stk-notice]'); if (!el) { if (isError) alert(msg); return; }
    el.hidden = false; el.setAttribute('aria-live', isError ? 'assertive' : 'polite');
    el.textContent = msg || ''; el.classList.toggle('is-error', !!isError); el.classList.toggle('is-empty', !msg);
    clearTimeout(this._nt);
    if (msg && !isError) this._nt = setTimeout(function () { el.textContent = ''; el.classList.add('is-empty'); }, 4000);
  };

  P.setBusy = function (b, label) {
    this.busy = b;
    this.root.classList.toggle('is-busy', b);
    $$(this.root, '[data-stk-add]').forEach(function (btn) {
      var span = $(btn, 'span'); if (!span) return;
      if (b) { if (!btn.hasAttribute('data-label')) btn.setAttribute('data-label', span.textContent); span.textContent = label || 'Hazırlanıyor…'; }
      else if (btn.hasAttribute('data-label')) { span.textContent = btn.getAttribute('data-label'); btn.removeAttribute('data-label'); }
    });
    // Hazırlık/yükleme sırasında model, dosya ve düzenleme girdileri kilitli (yanlış varyant/ölçü riski)
    $$(this.root, 'select, [data-stk-upload-trigger], [data-stk-remove], [data-stk-copy-surface], [data-stk-zoom], [data-stk-rot], [data-stk-qty], [data-stk-qty-step], .stk-cz__tab').forEach(function (el) { el.disabled = b; });
    if (b) $$(this.root, '[data-stk-action]').forEach(function (el) { el.disabled = true; });
    else this.updateControls();
    this.updateCTA();
  };
  P.setProgress = function (label) {
    $$(this.root, '[data-stk-add] span').forEach(function (span) { span.textContent = label; });
  };

  /* ------------------------------ mobil düzen ------------------------------ */
  // ≤989px: başlık/fiyat + "Modelini seç" adımı sahnenin ÜSTÜNE taşınır (önce model, sonra fotoğraf)
  P.bindArtFrame = function () {
    var self = this;
    var host = $(this.root, '[data-stk-frames]');
    if (host) {
      host.innerHTML = '';
      FRAME_COLORS.forEach(function (c) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'stk-cz__swatch'; b.setAttribute('data-stk-frame', c.n); b.title = c.n; b.setAttribute('aria-label', c.n);
        b.style.background = 'linear-gradient(135deg,' + c.c + ' 0%,' + c.grain + ' 100%)';
        on(b, 'click', function () { self.setFrameColor(c); });
        host.appendChild(b);
      });
      this.setFrameColor(FRAME_COLORS[0]);
    }
    // yüzey kartları → option1 select
    var sel = this.selects && this.selects[0];
    $$(this.root, '[data-stk-surface-opt]').forEach(function (b) {
      on(b, 'click', function () { if (!sel) return; sel.value = b.getAttribute('data-stk-surface-opt'); self.syncVariant(); self.paintSurfaceCards(); });
    });
    this.paintSurfaceCards();
    $$(this.root, '[data-stk-view]').forEach(function (b) { on(b, 'click', function () { self.setView(b.getAttribute('data-stk-view')); }); });
    var vh = $(this.root, '[data-stk-views]'); if (vh) vh.hidden = false;
  };
  P.paintSurfaceCards = function () {
    var v = this.variant, cur = v ? v.option1 : '';
    $$(this.root, '[data-stk-surface-opt]').forEach(function (b) { var onIt = b.getAttribute('data-stk-surface-opt') === cur; b.classList.toggle('is-on', onIt); b.setAttribute('aria-pressed', onIt ? 'true' : 'false'); });
  };
  P.bindMobileLayout = function () {
    var self = this, slot = $(this.root, '[data-stk-mobile-top]');
    var head = $(this.root, '[data-stk-head]'), step1 = $(this.root, '[data-stk-step1]');
    if (!slot || (!head && !step1)) return;
    var homeHead = head && head.parentNode, homeStep = step1 && step1.parentNode, nextStep = step1 && step1.nextSibling;
    var mq = window.matchMedia('(max-width: 989px)');
    var apply = function () {
      if (mq.matches) { if (head) slot.appendChild(head); if (step1) slot.appendChild(step1); slot.hidden = false; }
      else { if (head && homeHead) homeHead.insertBefore(head, homeHead.firstChild); if (step1 && homeStep) homeStep.insertBefore(step1, nextStep); slot.hidden = true; }
      if (self.device) self.resize();
    };
    if (mq.addEventListener) mq.addEventListener('change', apply); else if (mq.addListener) mq.addListener(apply);
    apply();
  };

  /* ------------------------------ kanvas etkileşimi ----------------------- */
  P.bindCanvas = function () {
    var self = this, c = this.canvas;
    c.style.touchAction = 'pan-y'; // dokunmatikte tek parmak kaydırma = sayfa kaydırma; taşıma için BASILI TUT (HOLD ms) veya iki parmak
    // Dokunmatik ayrımı: parmak HOLD süresince hareketsiz kalırsa taşıma modu (armed) başlar; erken hareket ederse tarayıcı sayfayı kaydırır.
    var HOLD = 220, holdTimer = null, pending = null, armed = false;
    var arm = function () {
      if (!pending) return;
      armed = true; c.classList.add('is-dragging');
      try { c.setPointerCapture(pending.id); } catch (x) { /* yoksay */ }
      self.pointers.set(pending.id, { x: pending.x, y: pending.y });
      pending = null; self.startGesture();
      try { if (navigator.vibrate) navigator.vibrate(10); } catch (x) { /* yoksay */ }
    };
    var disarm = function () { clearTimeout(holdTimer); holdTimer = null; pending = null; if (!self.pointers.size) { armed = false; c.classList.remove('is-dragging'); } };

    on(c, 'pointerdown', function (e) {
      if (!self.activeLayer()) return;
      if (self.category === 'artframe' && self.view !== 'front') return; // açı/köşe/duvar: yalnızca önizleme
      if (e.pointerType === 'touch' && !armed) {
        if (!pending) { // ilk parmak: basılı tutmayı bekle
          pending = { id: e.pointerId, x: e.clientX, y: e.clientY };
          clearTimeout(holdTimer); holdTimer = setTimeout(arm, HOLD);
          return;
        }
        clearTimeout(holdTimer); arm(); // ikinci parmak geldi: bekleme yok (yakınlaştır/döndür)
      }
      c.setPointerCapture(e.pointerId);
      self.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      self.startGesture();
      e.preventDefault();
    });
    on(c, 'pointermove', function (e) {
      if (pending && e.pointerId === pending.id) { // bekleme sırasında parmak kaydı → sayfa kaydırması, taşıma iptal
        if (Math.hypot(e.clientX - pending.x, e.clientY - pending.y) > 10) disarm();
        return;
      }
      if (!self.pointers.has(e.pointerId)) return;
      self.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      self.moveGesture();
      e.preventDefault();
    });
    var up = function (e) {
      if (pending && e.pointerId === pending.id) { disarm(); return; }
      if (!self.pointers.has(e.pointerId)) return;
      self.pointers.delete(e.pointerId);
      if (self.pointers.size) self.startGesture(); else { self.gesture = null; disarm(); }
      self.updateControls(); self.updateQuality(); self.updateCoverage();
    };
    on(c, 'pointerup', up); on(c, 'pointercancel', up); // pointer capture var: parmak sınırdan çıkınca hareket kesilmez
    // Taşıma modundayken tarayıcının dikey kaydırmasını engelle (touch-action pan-y'yi geçersiz kılar; parmak hareketsiz başladığı için iptal edilebilir)
    on(c, 'touchmove', function (e) { if (armed) e.preventDefault(); }, { passive: false });
    on(c, 'touchstart', function (e) { if (armed || self.pointers.size) e.preventDefault(); }, { passive: false });

    // Tekerlek: yalnızca Ctrl/⌘ ile (trackpad pinch de ctrlKey gönderir) — düz kaydırma sayfayı kaydırır
    on(c, 'wheel', function (e) {
      var L = self.activeLayer(); if (!L) return;
      if (!(e.ctrlKey || e.metaKey)) return;
      e.preventDefault();
      var r = c.getBoundingClientRect(), g = self.geo;
      var mx = (e.clientX - r.left - g.ox) / g.ppm - self.device.w / 2;
      var my = (e.clientY - r.top - g.oy) / g.ppm - self.device.h / 2;
      var f = Math.exp(-e.deltaY * 0.0015);
      self.zoomBy(f, mx, my); self.updateControls(); self.updateQuality(); self.draw();
    }, { passive: false });

    on(c, 'dblclick', function () { self.action('fill'); });
  };

  P.startGesture = function () {
    var L = this.activeLayer(); if (!L) return;
    var pts = Array.from(this.pointers.values());
    var g = { n: pts.length, x: L.x, y: L.y, scale: L.scale, zoomRel: L.zoomRel, rot: L.rot };
    if (pts.length === 1) { g.px = pts[0].x; g.py = pts[0].y; }
    else {
      g.mx = (pts[0].x + pts[1].x) / 2; g.my = (pts[0].y + pts[1].y) / 2;
      g.dist = Math.hypot(pts[1].x - pts[0].x, pts[1].y - pts[0].y) || 1;
      g.ang = Math.atan2(pts[1].y - pts[0].y, pts[1].x - pts[0].x);
    }
    this.gesture = g;
  };

  P.moveGesture = function () {
    var L = this.activeLayer(), g = this.gesture; if (!L || !g) return;
    var pts = Array.from(this.pointers.values());
    var ppm = this.geo.ppm;
    if (g.n === 1 && pts.length === 1) {
      L.x = g.x + (pts[0].x - g.px) / ppm;
      L.y = g.y + (pts[0].y - g.py) / ppm;
    } else if (pts.length >= 2) {
      var mx = (pts[0].x + pts[1].x) / 2, my = (pts[0].y + pts[1].y) / 2;
      var dist = Math.hypot(pts[1].x - pts[0].x, pts[1].y - pts[0].y) || 1;
      var ang = Math.atan2(pts[1].y - pts[0].y, pts[1].x - pts[0].x);
      var ratio = dist / g.dist, dth = ang - g.ang;
      var newRot = g.rot + dth * 180 / Math.PI;
      if (newRot > 180) newRot -= 360; if (newRot < -180) newRot += 360;
      // ölçek doğrudan parmak mesafesinden; zoomRel dönüşe göre türetilir
      var tmp = { w: L.w, h: L.h, rot: newRot };
      var zr = clamp(g.scale * ratio / this.coverScale(tmp), 0.2, 8);
      ratio = zr * this.coverScale(tmp) / g.scale;
      // görsel merkezini orta noktaya göre döndür + ölçekle (px uzayı)
      var r = this.canvas.getBoundingClientRect();
      var cx0 = r.left + this.geo.ox + (this.device.w / 2 + g.x) * ppm;
      var cy0 = r.top + this.geo.oy + (this.device.h / 2 + g.y) * ppm;
      var vx = cx0 - g.mx, vy = cy0 - g.my;
      var cos = Math.cos(dth), sin = Math.sin(dth);
      var nx = mx + (vx * cos - vy * sin) * ratio, ny = my + (vx * sin + vy * cos) * ratio;
      L.x = (nx - r.left - this.geo.ox) / ppm - this.device.w / 2;
      L.y = (ny - r.top - this.geo.oy) / ppm - this.device.h / 2;
      L.rot = newRot; L.zoomRel = zr; L.scale = g.scale * ratio;
    }
    this.updateControls(); this.draw();
  };

  /* --------------------------------- dışa aktarım ------------------------- */
  // Baskı dosyası: yüzeye özel cihaz ölçüsü; 20 MB'ı aşarsa önce kalite, sonra dpi kademeli düşer
  P.renderPrint = function (surface, snap) {
    var self = this, L = snap.layers[surface], d = snap.devices[surface], b = snap.bleed;
    var dpi = snap.dpi;
    var wmm = d.w + 2 * b, hmm = d.h + 2 * b;
    var px = wmm * dpi / MM_PER_INCH * hmm * dpi / MM_PER_INCH;
    if (px > PRINT_MAX_PIXELS) dpi = Math.floor(dpi * Math.sqrt(PRINT_MAX_PIXELS / px));
    var qualities = [0.94, 0.86, 0.78, 0.7];
    var attempt = function (qi, curDpi) {
      var ppm = curDpi / MM_PER_INCH;
      var c = document.createElement('canvas');
      c.width = Math.round(wmm * ppm); c.height = Math.round(hmm * ppm);
      var ctx = c.getContext('2d');
      ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, c.width, c.height);
      ctx.translate(b * ppm, b * ppm); ctx.scale(ppm, ppm);
      var restore = self.useSurface(surface); self.device = d;
      self.drawLayer(ctx, L, true);
      restore();
      return canvasToBlob(c, 'image/jpeg', qualities[qi]).then(function (blob) {
        if (blob.size > MAX_UPLOAD_BYTES) {
          if (qi < qualities.length - 1) return attempt(qi + 1, curDpi);
          if (curDpi > 150) return attempt(0, Math.max(150, Math.floor(curDpi * 0.85)));
          throw new Error('too_big');
        }
        return setJpegDpi(blob, curDpi).then(function (b2) { return { blob: b2, dpi: curDpi, w: c.width, h: c.height, wmm: wmm, hmm: hmm, quality: qualities[qi] }; });
      });
    };
    return attempt(0, dpi);
  };

  P.renderPreview = function (surface, snap) {
    var restore = this.useSurface(surface); this.device = snap.devices[surface];
    var keepLayer = this.layers[surface]; this.layers[surface] = snap.layers[surface];
    var W = 1000, H = Math.round(W / (this.category === 'macbook' ? 1.35 : 0.8));
    var keepView = this.view; if (this.category === 'artframe') this.view = 'front';
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var ctx = c.getContext('2d'); ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, W, H);
    var g = this.geometry(W, H, 30);
    this.drawScene(ctx, g, { interactive: false });
    this.layers[surface] = keepLayer; this.view = keepView;
    restore();
    return canvasToBlob(c, 'image/jpeg', 0.85);
  };

  // XHR ile yükleme: ilerleme yüzdesi + zaman aşımı + JSON olmayan yanıtlarda anlaşılır hata
  P.postCart = function (fd, onProgress) {
    var self = this;
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', self.cartUrl, true);
      xhr.timeout = UPLOAD_TIMEOUT;
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      if (xhr.upload && onProgress) xhr.upload.onprogress = function (e) { if (e.lengthComputable) onProgress(Math.round(e.loaded / e.total * 100)); };
      xhr.onload = function () {
        var json = null; try { json = JSON.parse(xhr.responseText); } catch (e) { json = null; }
        if (xhr.status >= 200 && xhr.status < 300 && json) return resolve(json);
        var msg = json && (json.description || json.message);
        if (!msg) msg = xhr.status === 413 ? self.t('err_413', 'Dosyalar sunucu sınırını aştı. Lütfen daha küçük bir fotoğraf deneyin.')
          : xhr.status === 429 ? self.t('err_429', 'Çok fazla istek. Lütfen biraz bekleyip tekrar deneyin.')
          : xhr.status === 422 ? self.t('err_422', 'Bu model şu an sepete eklenemiyor (stok). Lütfen başka bir model seçin.')
          : self.t('err_http', 'Sunucu hatası ({status}). Lütfen tekrar deneyin.').replace('{status}', xhr.status);
        reject(new Error(msg));
      };
      xhr.onerror = function () { reject(new Error(self.t('err_net', 'Bağlantı hatası. İnternetini kontrol edip tekrar dene.'))); };
      xhr.ontimeout = function () { reject(new Error(self.t('err_timeout', 'Yükleme zaman aşımına uğradı. Daha hızlı bir bağlantıda tekrar dene.'))); };
      xhr.send(fd);
    });
  };

  P.addToCart = function () {
    var self = this;
    if (this.busy) return;
    var v = this.variant; if (!v) return;
    var missing = this.surfaces.filter(function (s) { return !(self.layers[s] && self.layers[s].img); });
    if (missing.length) { this.updateCTA(); return; }

    if (v.available === false) { this.updateCTA(); return; }
    // Anlık kopya: hazırlık sırasında model/yüzey/görsel değişse bile sipariş tutarlı kalır
    var snap = { v: v, surfaces: this.surfaces.slice(), layers: {}, devices: {}, bleed: this.bleed, dpi: this.dpi, model: v.option1 || '' };
    snap.surfaces.forEach(function (s) { var L = self.layers[s]; var c = {}; for (var k in L) c[k] = L[k]; snap.layers[s] = c; snap.devices[s] = self.deviceFor(s); });
    var total = snap.surfaces.length, step = 0;
    this.setBusy(true, this.t('preparing', 'Baskı dosyası hazırlanıyor…'));
    var fd = new FormData();
    fd.append('id', v.id);
    fd.append('quantity', clamp(parseInt(($(this.root, '[data-stk-qty]') || {}).value, 10) || 1, 1, 99));
    (this.product.options || []).forEach(function (name, i) {
      var val = v['option' + (i + 1)]; if (!val) return;
      fd.append('properties[' + (i === 0 && self.category !== 'artframe' ? 'Model' : name) + ']', val);
    });
    if (this.category === 'artframe' && this.frameColor) fd.append('properties[Çerçeve Rengi]', this.frameColor.n);
    fd.append('properties[_Kişiselleştirme]', 'Evet');

    var base = 'stickidy-' + slug(this.product.handle || 'kaplama') + '-' + slug(v.option1 || 'model');
    var settings = {}, totalBytes = 0;
    var chain = Promise.resolve();
    snap.surfaces.forEach(function (s) {
      var L = snap.layers[s];
      var suffix = total > 1 ? ' (' + SURFACE_LABELS[s] + ')' : '';
      chain = chain.then(function () {
        step++; self.setProgress(self.t('preparing_n', 'Baskı dosyası hazırlanıyor {i}/{n}…').replace('{i}', step).replace('{n}', total));
        return self.renderPrint(s, snap);
      }).then(function (out) {
        totalBytes += out.blob.size;
        var fname = base + (total > 1 ? '-' + s : '') + '-' + Math.round(out.wmm) + 'x' + Math.round(out.hmm) + 'mm-' + out.dpi + 'dpi-print.jpg';
        fd.append('properties[Baskı Dosyası' + suffix + ']', out.blob, fname);
        // Shopify yüklenen dosyayı yeniden kodlar ve adını hash yapar → ölçü/dpi bilgisi siparişte görünür bir alanda
        fd.append('properties[Baskı Ölçüsü' + suffix + ']', (Math.round(out.wmm * 10) / 10).toString().replace('.', ',') + ' × ' + (Math.round(out.hmm * 10) / 10).toString().replace('.', ',') + ' mm · ' + out.dpi + ' dpi · ' + out.w + '×' + out.h + ' px (taşma ' + snap.bleed + ' mm dahil)');
        settings[s] = { x: +L.x.toFixed(2), y: +L.y.toFixed(2), rot: +L.rot.toFixed(2), zoom: +(L.zoomRel || 1).toFixed(3), flipX: L.fx, flipY: L.fy, dpi: out.dpi, quality: out.quality, px: out.w + 'x' + out.h, mm: Math.round(out.wmm * 10) / 10 + 'x' + Math.round(out.hmm * 10) / 10, src: (L.srcW || L.w) + 'x' + (L.srcH || L.h), covers: self.covers(L, snap.devices[s]) };
        return self.renderPreview(s, snap);
      }).then(function (pv) {
        totalBytes += pv.size;
        fd.append('properties[Önizleme' + suffix + ']', pv, base + (total > 1 ? '-' + s : '') + '-onizleme.jpg');
      });
    });

    chain.then(function () {
      if (totalBytes > MAX_TOTAL_BYTES) throw new Error('too_big');
      var devs = {}; snap.surfaces.forEach(function (s) { devs[s] = { w: snap.devices[s].w, h: snap.devices[s].h, known: snap.devices[s].known !== false }; });
      var known = snap.surfaces.every(function (s) { return snap.devices[s].known !== false; });
      var meta = { device: { w: snap.devices[snap.surfaces[0]].w, h: snap.devices[snap.surfaces[0]].h, bleed: snap.bleed }, devices: devs, surfaces: settings };
      if (self.category === 'artframe') { meta.frame = self.frameColor ? self.frameColor.n : ''; meta.surfaceType = snap.v.option1 || ''; }
      if (!known) { meta.modelBilinmiyor = true; meta.model = snap.model; }
      fd.append('properties[_Tasarım Ayarları]', JSON.stringify(meta));
      if (!known) fd.append('properties[_Model Uyarısı]', 'Ölçü tablosunda yok: ' + snap.model + ' — kategori varsayılanıyla basıldı, kontrol edin');
      // Tema sepet çekmecesi bölümleri
      var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      try {
        if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
          fd.append('sections', cartEl.getSectionsToRender().map(function (s) { return s.id; }).join(','));
          fd.append('sections_url', window.location.pathname);
          if (typeof cartEl.setActiveElement === 'function') cartEl.setActiveElement(document.activeElement);
        }
      } catch (e) { /* yoksay */ }
      self.setProgress(self.t('uploading', 'Yükleniyor…'));
      return self.postCart(fd, function (pct) { self.setProgress(self.t('uploading_pct', 'Yükleniyor %{pct}').replace('{pct}', pct)); });
    }).then(function (json) {
      self.setBusy(false);
      self.notice(self.t('added', 'Sepete eklendi'));
      var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var handled = false;
      try {
        if (cartEl && typeof cartEl.renderContents === 'function') {
          // Tema (Dawn tabanlı): boş sepetten ilk eklemede `is-empty` sınıfı hem çekmecede hem iç kapsayıcıda kalkmalı
          cartEl.classList.remove('is-empty');
          var inner = cartEl.querySelector('.drawer__inner'); if (inner) inner.classList.remove('is-empty');
          cartEl.renderContents(json);
          cartEl.classList.remove('is-empty');
          handled = true;
        }
      } catch (e) { handled = false; }
      try {
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: v.id });
        }
      } catch (e) { /* yoksay */ }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('stickidy:added', { detail: json, bubbles: true }));
      if (!handled) {
        // Çekmece API'si yoksa/değiştiyse: çekmeceyi açmayı dene, olmazsa sepet sayfasına git
        try { if (cartEl && typeof cartEl.open === 'function') { cartEl.open(); handled = true; } } catch (e) { handled = false; }
        if (!handled && !self.root.hasAttribute('data-stk-no-redirect')) window.location.href = self.root.getAttribute('data-cart-page') || '/cart';
      }
    }).catch(function (err) {
      self.setBusy(false);
      var msg = err && err.message === 'too_big'
        ? self.t('err_big', 'Baskı dosyaları toplamda 20 MB sınırını aşıyor. Tam Kaplama yerine Üst/Alt kapak seçin ya da daha küçük bir fotoğraf deneyin.')
        : self.t('err_cart', 'Sepete eklenemedi: ') + (err && err.message ? err.message : '');
      self.notice(msg, true);
      console.error('[stickidy] addToCart', err);
    });
  };

  /* --------------------------------- başlat ------------------------------- */
  function init() {
    $$(document, '[data-stk-customizer]:not(.is-ready)').forEach(function (el) { el.__stk = new StickidyCustomizer(el); });
  }
  window.StickidyCustomizer = StickidyCustomizer;
  window.StickidyCustomizer.init = init;
  window.StickidyCustomizer.DEVICES = DEVICES;
  if (document.readyState === 'loading') on(document, 'DOMContentLoaded', init); else init();
  on(document, 'shopify:section:load', init);
})();
